import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/Actions/actions";
import ColorPicker from "../../Tool/ColorPicker/ColorPicker";
import "bootstrap/dist/css/bootstrap.min.css";
import Popup from "../../Modal/Popup";
import Counter from "../../Tool/Counter/Counter";
import BackgroundImageControl from "./BackgroundControl/BackgroundImageControl";
import Confirm from "../../Modal/Confirm";
import rgba from "rgba-convert";
import cloneDeep from "lodash.clonedeep";
import shortid from "shortid";
import {
  Alert,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Collapse,
} from "reactstrap";
import "./Style.scss";
import classnames from "classnames";
import { SketchPicker } from "react-color";
import reactCSS from "reactcss";
import ImagesContent from "../../Modal/Library/Content/ImagesContent";
import UnitSelector from "../UnitSelector/UnitSelector";
import * as UTILS from "../../../utils/Utils";
import "../ColorPicker/ColorPicker.scss";
import Axios from "../../../axios";

const elementsFontKeysArray = [
  {
    label: "Heading 1",
    name: "h1",
    tagNum: 1,
    fontSize: "36",
    fontFamily: "",
    color: { r: 0, g: 0, b: 0, a: 1 },
    marginBottom: "0",
  },
  {
    label: "Heading 2",
    name: "h2",
    tagNum: 2,
    fontSize: "32",
    fontFamily: "",
    color: { r: 0, g: 0, b: 0, a: 1 },
    marginBottom: "0",
  },
  {
    label: "Heading 3",
    name: "h3",
    tagNum: 3,
    fontSize: "28",
    fontFamily: "",
    color: { r: 0, g: 0, b: 0, a: 1 },
    marginBottom: "0",
  },
  {
    label: "Heading 4",
    name: "h4",
    tagNum: 4,
    fontSize: "20",
    fontFamily: "",
    color: { r: 0, g: 0, b: 0, a: 1 },
    marginBottom: "0",
  },
  {
    label: "Paragraph",
    name: "p",
    tagNum: 5,
    fontSize: "16",
    fontFamily: "",
    color: { r: 0, g: 0, b: 0, a: 1 },
    marginBottom: "0",
  },
];

const globalTagsStyleObj = {
  font_family: "",
  background_color: "",
  color: "",
  font_size: "",
  font_style: "",
  line_height: "",
  margin_bottom: "",
};

const lineheight_formats = [
  "1",
  "1.1",
  "1.2",
  "1.25",
  "1.3",
  "1.4",
  "1.5",
  "2",
];
// const fontsize_formats = ["8px", "9px", "10px", "11px", "12px", "13px", "14px", "15px", "16px", "17px", "18px", "19px", "20px", "24px", "28px", "32px", "36px"];

class Style extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeSubTab: "1",
      activeTab: "1",
      bgColorChoosen: "",
      bgImage: "",
      bgImageIndex: "",
      bgType: "",
      changesStored: false,
      changeHandle: "#000",
      choosenFont: "",
      collapse: 0,
      colorGlobal: { rgb: { a: 1, b: 0, g: 0, r: 0 }, hex: "#000000" },
      colorPicker: false,
      colorsAdded: [],
      columnGap: "0",
      croppedImage: "",
      currentlyAddedGlobalColor: {
        rgb: { a: 1, b: 0, g: 0, r: 0 },
        hex: "#000000",
      },
      containerSetting: false,
      displayColorPicker: false,
      displayHamburgerColorPicker: false,
      globalModal: false,
      globalColorPicker: false,
      imagePreview: "",
      imagesGlobal: [],
      library: false,
      libraryContainer: false,
      mobileMargin: false,
      mobilePadding: false,
      mobilePadding: false,
      pixelWidth: 1200,
      presetAdded: [],
      selectedOverrideFont: null,
      selectedWidthOption: "",
      rowGap: "0",
      bgColor: this.props.containerBg
        ? this.props.containerBg
        : { r: 252, g: 252, b: 252, a: 1 },
      bgContainerRepeat: this.props.bgContainerRepeat
        ? this.props.bgContainerRepeat
        : "no-repeat",
      bgContainerSize: this.props.bgContainerSize
        ? this.props.bgContainerSize
        : "auto",
      bgImageContainer: this.props.bgImageContainer
        ? this.props.bgImageContainer
        : "",
      bgImageContainerId: this.props.bgImageContainerId
        ? this.props.bgImageContainerId
        : "",
      bgImageId: this.props.bgImageId ? this.props.bgImageId : "",
      bgVideo: this.props.bgVideo,
      bgVideoId: this.props.bgVideoId,
      canvasPadding: this.props.canvasStyle
        ? this.props.canvasStyle.canvasPadding
        : [0, 0, 0, 0],
      canvasPaddingMobile: this.props.canvasStyle
        ? this.props.canvasStyle.canvasPaddingMobile
        : [0, 0, 0, 0],
      canvasPaddingUnit:
        this.props.canvasStyle && this.props.canvasStyle.canvasPaddingUnit
          ? this.props.canvasStyle.canvasPaddingUnit
          : "px",
      canvasMargin: this.props.canvasStyle
        ? this.props.canvasStyle.canvasMargin
        : [0, 0],
      canvasMarginMobile: this.props.canvasStyle
        ? this.props.canvasStyle.canvasMarginMobile
        : [0, 0],
      canvasMarginUnit:
        this.props.canvasStyle && this.props.canvasStyle.canvasMarginUnit
          ? this.props.canvasStyle.canvasMarginUnit
          : "px",
      canvasRowsPadding: this.props.canvasStyle
        ? this.props.canvasStyle.canvasRowsPadding
        : [0, 0, 0, 0],
      canvasRowsPaddingMobile: this.props.canvasStyle
        ? this.props.canvasStyle.canvasRowsPaddingMobile
        : [0, 0, 0, 0],
      canvasRowsPaddingUnit:
        this.props.canvasStyle && this.props.canvasStyle.canvasRowsPaddingUnit
          ? this.props.canvasStyle.canvasRowsPaddingUnit
          : "px",
      containerWidth: this.props.containerWidth,
      overrideCanvasFont: this.props.canvasStyle
        ? this.props.canvasStyle.overrideCanvasFont
        : false,
      percentage: this.props.percentage,
      pixel: this.props.pixel,
      selectedFont: this.props.selectedFont,
      surroundBg: this.props.surroundBg
        ? this.props.surroundBg
        : { r: 252, g: 252, b: 252, a: 1 },
    };

    const elementsFontObj = {};
    let cards = [];

    // Variables ENDS
    this.bgColorhandleChange = this.bgColorhandleChange.bind(this);
    this.counter = React.createRef();
    this.getImageContent = this.getImageContent.bind(this);
    this.handleClickColor = this.handleClickColor.bind(this);
    this.handleOutsideClickColor = this.handleOutsideClickColor.bind(this);
    this.surroundBgColorhandleChange =
      this.surroundBgColorhandleChange.bind(this);
    this.selectFont = this.selectFont.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleGlobalStyle = this.toggleGlobalStyle.bind(this);
    this.widthOnChange = this.widthOnChange.bind(this);
  }

  // LOCAL OVERRIDE STARTS
  formatText = (textVal, property, tag) => {
    var myString = textVal;
    let elementID = "F" + shortid();
    var divElement = document.createElement("div");
    divElement.id = elementID;
    divElement.innerHTML = myString;

    if (divElement.getElementsByTagName(tag).length > 0) {
      var elements = divElement.getElementsByTagName("*");

      for (var i = 0; i < elements.length; i++) {
        // remove the style attribute enterily if it contains font-size property
        if ((elements[i].getAttribute("style") || "").includes(property)) {
          elements[i].style.removeProperty(property);
          elements[i].style.fontFamily = this.props.selectedFont;
        }
      }
    }
    // loop through ALL DOM elements insidie the divElement
    return divElement.innerHTML;
  };

  formatTextAndSave = (property, tag) => {
    const layoutList = cloneDeep(this.props.layoutList);

    const listPages = layoutList.map((layout) => {
      layout[1].map((item, itemIndex) => {
        if (item.data == `TEXT`) {
          item.text = this.formatText(item.text, property, tag);
          item.style.fontFamily = this.state.selectedOverrideFont;

          return item;
        }
        if (item.data == `BUTTON`) {
          item.style.fontFamily = this.state.selectedOverrideFont;
          return item;
        }
        if (item.data == `FORM`) {
          item.style.fontFamily = this.state.selectedOverrideFont;
          return item;
        }
        if (item.data == `HTML`) {
          item.style.fontFamily = this.state.selectedOverrideFont;
          return item;
        }
        if (item.data == "Row") {
          Object.keys(item.columns).map((col, colIndex) => {
            return item.columns[col].map((colItem, colItemIndex) => {
              if (colItem.data == `TEXT`) {
                colItem.text = this.formatText(colItem.text, property, tag);
                colItem.style.fontFamily = this.state.selectedOverrideFont;
                return colItem;
              }
              if (colItem.data == `BUTTON`) {
                !("style" in colItem) && (colItem.style = {});
                colItem.style.fontFamily = this.state.selectedOverrideFont;
                return colItem;
              }
              if (colItem.data == `FORM`) {
                !("style" in colItem) && (colItem.style = {});
                colItem.style.fontFamily = this.state.selectedOverrideFont;
                return colItem;
              }
              if (colItem.data == `HTML`) {
                !("style" in colItem) && (colItem.style = {});
                colItem.style.fontFamily = this.state.selectedOverrideFont;
                return colItem;
              } else if (colItem.data == "Row") {
                Object.keys(colItem.columns).map((colNested, colIndex) => {
                  return colItem.columns[colNested].map(
                    (colItemNested, colItemNestedIndex) => {
                      if (colItemNested.data == `TEXT`) {
                        // itemThird(colItemNested);
                        colItemNested.text = this.formatText(
                          colItemNested.text,
                          property,
                          tag
                        );
                        colItemNested.style.fontFamily =
                          this.state.selectedOverrideFont;
                        return colItemNested;
                      }
                      if (colItemNested.data == `BUTTON`) {
                        !("style" in colItemNested) &&
                          (colItemNested.style = {});
                        colItemNested.style.fontFamily =
                          this.state.selectedOverrideFont;
                        return colItemNested;
                      }
                      if (colItemNested.data == `FORM`) {
                        !("style" in colItemNested) &&
                          (colItemNested.style = {});
                        colItemNested.style.fontFamily =
                          this.state.selectedOverrideFont;
                        return colItemNested;
                      }
                      if (colItemNested.data == `HTML`) {
                        !("style" in colItemNested) &&
                          (colItemNested.style = {});
                        colItemNested.style.fontFamily =
                          this.state.selectedOverrideFont;
                        return colItemNested;
                      }
                      return colItemNested;
                    }
                  );
                });
              }
              return colItem;
            });
          });
        }
        return item;
      });
      return layout;
    });

    this.props.replace_microsite(listPages);
    const layout = cloneDeep(this.props.layout);
    const newLayout = layout.map((item, itemIndex) => {
      if (item.data == `TEXT`) {
        // itemFirst(item);
        item.text = this.formatText(item.text, property, tag);
        item.style.fontFamily = this.state.selectedOverrideFont;
        return item;
      }
      if (item.data == `BUTTON`) {
        !("style" in item) && (item.style = {});
        item.style.fontFamily = this.state.selectedOverrideFont;
        return item;
      }
      if (item.data == `FORM`) {
        !("style" in item) && (item.style = {});
        item.style.fontFamily = this.state.selectedOverrideFont;
        return item;
      }
      if (item.data == `HTML`) {
        !("style" in item) && (item.style = {});
        item.style.fontFamily = this.state.selectedOverrideFont;
        return item;
      }
      if (item.data == "Row") {
        Object.keys(item.columns).map((col, colIndex) => {
          return item.columns[col].map((colItem, colItemIndex) => {
            if (colItem.data == `TEXT`) {
              // itemSecond(colItem);
              colItem.text = this.formatText(colItem.text, property, tag);
              colItem.style.fontFamily = this.state.selectedOverrideFont;
              return colItem;
            }
            if (colItem.data == `BUTTON`) {
              !("style" in colItem) && (colItem.style = {});
              colItem.style.fontFamily = this.state.selectedOverrideFont;
              return colItem;
            }
            if (colItem.data == `FORM`) {
              !("style" in colItem) && (colItem.style = {});
              colItem.style.fontFamily = this.state.selectedOverrideFont;
              return colItem;
            }
            if (colItem.data == `HTML`) {
              !("style" in colItem) && (colItem.style = {});
              colItem.style.fontFamily = this.state.selectedOverrideFont;
              return colItem;
            } else if (colItem.data == "Row") {
              Object.keys(colItem.columns).map((colNested, colIndex) => {
                return colItem.columns[colNested].map(
                  (colItemNested, colItemNestedIndex) => {
                    if (colItemNested.data == `TEXT`) {
                      // itemThird(colItemNested);
                      colItemNested.text = this.formatText(
                        colItemNested.text,
                        property,
                        tag
                      );
                      colItemNested.style.fontFamily =
                        this.state.selectedOverrideFont;
                      return colItemNested;
                    }
                    if (colItemNested.data == `BUTTON`) {
                      !("style" in colItemNested) && (colItemNested.style = {});
                      colItemNested.style.fontFamily =
                        this.state.selectedOverrideFont;
                      return colItemNested;
                    }
                    if (colItemNested.data == `FORM`) {
                      !("style" in colItemNested) && (colItemNested.style = {});
                      colItemNested.style.fontFamily =
                        this.state.selectedOverrideFont;
                      return colItemNested;
                    }
                    if (colItemNested.data == `HTML`) {
                      !("style" in colItemNested) && (colItemNested.style = {});
                      colItemNested.style.fontFamily =
                        this.state.selectedOverrideFont;
                      return colItemNested;
                    }
                    return colItemNested;
                  }
                );
              });
            }
            return colItem;
          });
        });
      }
      return item;
    });
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  // LOCAL OVERRIDE STYLE ENDS
  addPropertyText = (textVal, property, tag, getStyleValue) => {
    var myString = textVal;
    let styleObj = getStyleValue;
    let elementID = "F" + shortid();
    var divElement = document.createElement("div");
    divElement.id = elementID;
    divElement.innerHTML = myString;
    if (divElement.getElementsByTagName(JSON.parse(tag)).length > 0) {
      var elements = divElement.querySelectorAll(JSON.parse(tag));

      for (var i = 0; i < elements.length; i++) {
        // (elements[i].getAttribute("style")==null || elements[i].getAttribute("style")=="") && elements[i].setAttribute("style", "");
        elements[i].style.paddingBottom = styleObj.margin_bottom
          ? styleObj.margin_bottom + "px"
          : 0;
        elements[i].style.fontFamily = styleObj.font_family
          ? styleObj.font_family
          : "";
        elements[i].style.fontSize = styleObj.font_size
          ? styleObj.font_size + "px"
          : "";
        elements[i].style.lineHeight = styleObj.line_height
          ? styleObj.line_height
          : "";

        elements[i].style.fontWeight = "";
        elements[i].style.fontStyle = styleObj.font_style
          ? styleObj.font_style
          : "";
        elements[i].style.textDecoration = "";
        elements[i].style.marginBottom = "0px";
        elements[i].style.color = styleObj.color
          ? `rgba(
                ${styleObj.color.r},
                ${styleObj.color.g},
                ${styleObj.color.b},
                ${styleObj.color.a}
              )`
          : "";
        elements[i].style.backgroundColor = styleObj.background_color
          ? `rgba(
                ${styleObj.background_color.r},
                ${styleObj.background_color.g},
                ${styleObj.background_color.b},
                ${styleObj.background_color.a}
              )`
          : "";

        var childElements = elements[i].querySelectorAll("span");
        for (var c = 0; c < childElements.length; c++) {
          childElements[c].style.paddingBottom = styleObj.margin_bottom
            ? styleObj.margin_bottom + "px"
            : 0;
          childElements[c].style.fontFamily = styleObj.font_family
            ? styleObj.font_family
            : "";
          childElements[c].style.fontSize = styleObj.font_size
            ? styleObj.font_size + "px"
            : "";
          childElements[c].style.lineHeight = styleObj.line_height
            ? styleObj.line_height
            : "";

          childElements[c].style.fontWeight = styleObj.font_weight
            ? styleObj.font_weight
            : "";
          childElements[c].style.fontStyle = "";
          childElements[c].style.textDecoration = "";
          childElements[c].style.marginBottom = "0px";
          childElements[c].style.color = styleObj.color
            ? `rgba(
                  ${styleObj.color.r},
                  ${styleObj.color.g},
                  ${styleObj.color.b},
                  ${styleObj.color.a}
                )`
            : "";
          childElements[c].style.backgroundColor = styleObj.background_color
            ? `rgba(
                  ${styleObj.background_color.r},
                  ${styleObj.background_color.g},
                  ${styleObj.background_color.b},
                  ${styleObj.background_color.a}
                )`
            : "";
        }
      }
    }

    return divElement.innerHTML;
  };

  addTextPropertyAndSave = (property, tag, getStyleValue) => {
    const layoutList = cloneDeep(this.props.layoutList);
    const listPages = layoutList.map((layout) => {
      layout[1].map((item, itemIndex) => {
        if (item.data == `TEXT`) {
          // itemFirst(item);
          item.text = this.addPropertyText(
            item.text,
            property,
            tag,
            getStyleValue
          );
          return item;
        }
        if (item.data == "Row") {
          Object.keys(item.columns).map((col, colIndex) => {
            return item.columns[col].map((colItem, colItemIndex) => {
              if (colItem.data == `TEXT`) {
                // itemSecond(colItem);
                colItem.text = this.addPropertyText(
                  colItem.text,
                  property,
                  tag,
                  getStyleValue
                );
                return colItem;
              } else if (colItem.data == "Row") {
                Object.keys(colItem.columns).map((colNested, colIndex) => {
                  return colItem.columns[colNested].map(
                    (colItemNested, colItemNestedIndex) => {
                      if (colItemNested.data == `TEXT`) {
                        // itemThird(colItemNested);
                        colItemNested.text = this.addPropertyText(
                          colItemNested.text,
                          property,
                          tag,
                          getStyleValue
                        );
                        return colItemNested;
                      }
                      return colItemNested;
                    }
                  );
                });
              }
              return colItem;
            });
          });
        }
        return item;
      });
      return layout;
    });

    this.props.replace_microsite(listPages);
    const layout = cloneDeep(this.props.layout);
    const newLayout = layout.map((item, itemIndex) => {
      if (item.data == `TEXT`) {
        // itemFirst(item);
        item.text = this.addPropertyText(
          item.text,
          property,
          tag,
          getStyleValue
        );
        return item;
      }
      if (item.data == "Row") {
        Object.keys(item.columns).map((col, colIndex) => {
          return item.columns[col].map((colItem, colItemIndex) => {
            if (colItem.data == `TEXT`) {
              // itemSecond(colItem);
              colItem.text = this.addPropertyText(
                colItem.text,
                property,
                tag,
                getStyleValue
              );

              return colItem;
            } else if (colItem.data == "Row") {
              Object.keys(colItem.columns).map((colNested, colIndex) => {
                return colItem.columns[colNested].map(
                  (colItemNested, colItemNestedIndex) => {
                    if (colItemNested.data == `TEXT`) {
                      // itemThird(colItemNested);
                      colItemNested.text = this.addPropertyText(
                        colItemNested.text,
                        property,
                        tag,
                        getStyleValue
                      );
                      return colItemNested;
                    }
                    return colItemNested;
                  }
                );
              });
            }
            return colItem;
          });
        });
      }
      return item;
    });
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  componentDidMount = () => {
    this._isMounted = true;
    const foundMobilePadding = this.props.canvasStyle
      ? this.props.canvasStyle.canvasPaddingMobile.find((item, index) => {
          return item !== "0";
        })
      : "0";
    const foundMobileMargin = this.props.canvasStyle
      ? this.props.canvasStyle.canvasMarginMobile.find((item, index) => {
          return item !== "0";
        })
      : "0";

    const getContainerWidth =
      typeof this.props.containerWidth == "string" && this.state.pixel
        ? JSON.parse(this.props.containerWidth.match(/\d+/g)[0])
        : this.props.containerWidth;


    this.bgColor = this.props.containerBgColor;
    // const self = this;
    this.bgColor = this.props.containerBg;
    this.setState({
      selectedOverrideFont: this.props.selectedFont,
      colorGlobal: this.props.glblClrs,
      preset: this.props.preset,
      presetAdded: this.props.preset,
      bgImage: this.props.bgImage,
      bgImageContainer: this.props.bgImageContainer,
      surroundBg: this.props.surroundBg
        ? this.props.surroundBg
        : { r: 252, g: 252, b: 252, a: 1 },
      bgImageId: this.props.bgImageId,
      canvasPaddingUnit:
        this.props.canvasStyle && this.props.canvasStyle.canvasPaddingUnit
          ? this.props.canvasStyle.canvasPaddingUnit
          : "px",
      canvasPadding: this.props.canvasStyle
        ? this.props.canvasStyle.canvasPadding
        : [0, 0, 0, 0],
      canvasPaddingMobile: this.props.canvasStyle
        ? this.props.canvasStyle.canvasPaddingMobile
        : [0, 0, 0, 0],
      canvasMarginUnit:
        this.props.canvasStyle && this.props.canvasStyle.canvasMarginUnit
          ? this.props.canvasStyle.canvasMarginUnit
          : "px",
      canvasMargin: this.props.canvasStyle
        ? this.props.canvasStyle.canvasMargin
        : [0, 0],
      canvasMarginMobile: this.props.canvasStyle
        ? this.props.canvasStyle.canvasMarginMobile
        : [0, 0],

      canvasRowsPaddingUnit:
        this.props.canvasStyle && this.props.canvasStyle.canvasRowsPaddingUnit
          ? this.props.canvasStyle.canvasRowsPaddingUnit
          : "px",
      canvasRowsPadding: this.props.canvasStyle
        ? this.props.canvasStyle.canvasRowsPadding
        : [0, 0, 0, 0],
      canvasRowsPaddingMobile: this.props.canvasStyle
        ? this.props.canvasStyle.canvasRowsPaddingMobile
        : [0, 0, 0, 0],
      overrideCanvasFont: this.props.canvasStyle
        ? this.props.canvasStyle.overrideCanvasFont
        : false,
      bgImageContainerId: this.props.bgImageContainerId,
      bgType: this.props.bgType,
      bgVideo: this.props.bgVideo,
      bgVideoId: this.props.bgVideoId,
      selectedFont: this.props.selectedFont,
      mobilePadding: foundMobilePadding == 0 ? false : true,
      mobileMargin: foundMobileMargin == 0 ? false : true,
      elementsFontObj:
        this.props.canvasStyle && this.props.canvasStyle.elementsFont
          ? { ...this.props.canvasStyle.elementsFont }
          : { ...this.state.elementsFontObj },
      columnGap:
        this.props.canvasStyle && this.props.canvasStyle.columnGap
          ? this.props.canvasStyle.columnGap
          : this.state.columnGap,
      rowGap:
        this.props.canvasStyle && this.props.canvasStyle.rowGap
          ? this.props.canvasStyle.rowGap
          : this.state.rowGap,
      mobileGap:
        this.props.canvasStyle && this.props.canvasStyle.rowGap ? true : false,
    });

    const bgImageIndex = this.props.bgImageIndex;
    this.setState({
      bgImageIndex: bgImageIndex,
    });
    // Selected global font

    this.setState({
      selectedFont: this.props.selectedFont,
    });

    // Container width
    const containerWidth = getContainerWidth;
    this.setState({
      containerWidth: containerWidth,
    });

    // Container width PIXEL
    const pixel = this.props.pixel;
    // self.setState({
    this.setState({
      pixel: pixel,
    });
    // Container width PERCENTAGE
    const percentage = this.props.percentage;
    // self.setState({
    this.setState({
      percentage: percentage,
    });

    if (this.props.glblClrs.length > 0 && this.props.preset.length > 0) {
      const glblClrs = JSON.parse(JSON.stringify(this.props.glblClrs));
      //const preset = JSON.parse(JSON.stringify(this.props.preset));
      this.setState({
        colorsAdded: glblClrs,
        //   presetAdded: preset
      });
    } else {
    }
  };
  componentWillUnmount = () => {
    this.props.newChangeDetected(true);
    this._isMounted = false;
  };

  //Color Palette
  handleClickColor() {
    if (!this.state.colorPicker) {
      document.addEventListener("click", this.handleOutsideClickColor, false);
    } else {
      document.removeEventListener(
        "click",
        this.handleOutsideClickColor,
        false
      );
    }
    this.setState((prevState) => ({
      colorPicker: !prevState.colorPicker,
    }));
  }

  bgColorChoosen = () => {
    const bgColorNew = this.bgColor;
    this.bgColor = bgColorNew;
    this.setState({
      colorPicker: false,
    });
  };

  handleOutsideClickColor(e) {
    // ignore clicks on the component itself
    if (this.colorNode.contains(e.target)) {
      return;
    }
    this.handleClickColor();
  }

  //Global Colors
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  toggleSubTab(subTab) {
    if (this.state.activeSubTab !== subTab) {
      this.setState({
        activeSubTab: subTab,
      });
    }
  }

  handleGlobalClick = () => {
    this.setState({
      displayColorPicker: !this.state.displayColorPicker,
    });
  };

  handleGlobalClose = () => {
    this.setState({ displayColorPicker: false });
  };

  bgColorhandleChange = (bgColor) => {
    this.setState(
      {
        bgColor: bgColor.rgb,
      },
      () => {
        this.props.pushBgColor(this.state.bgColor);
      }
    );
  };

  surroundBgColorhandleChange = (bgColor) => {
    this.setState(
      {
        surroundBg: bgColor.rgb,
      },
      () => {
        this.props.pushSurroundBg(this.state.surroundBg);
      }
    );
  };

  addGlobalColor = () => {
    let globalClr = this.state.colorsAdded;
    let getColor = this.state.currentlyAddedGlobalColor;
    var found = globalClr.find(function (element) {
      return element.hex === getColor.hex;
    });

    const sortedRGBA = `rgba(${this.state.currentlyAddedGlobalColor.rgb.r}, ${this.state.currentlyAddedGlobalColor.rgb.g}, ${this.state.currentlyAddedGlobalColor.rgb.b}, ${this.state.currentlyAddedGlobalColor.rgb.a})`;

    if (!found) {
      let colorGlobal = JSON.parse(
        JSON.stringify(this.state.currentlyAddedGlobalColor)
      );
      let preset = rgba.hex(sortedRGBA);
      this.setState(
        {
          colorsAdded: [...this.state.colorsAdded, colorGlobal],
          presetAdded: [...this.state.presetAdded, preset],
          displayColorPicker: false,
        },
        () => {
          this.props.pushGlobalColorArray(this.state.colorsAdded);
          this.props.pushGlobalColorPreset(this.state.presetAdded);
        }
      );
    } else {
      this.setState({
        ...this.state,
        sameColorAlert: true,
        displayColorPicker: false,
      });
      setTimeout(() => {
        this.setState({
          ...this.state,
          sameColorAlert: false,
        });
      }, 3000);
    }
  };

  deleteColor = (index) => {
    const globalColors = JSON.parse(JSON.stringify(this.state.colorsAdded));
    globalColors.splice(index, 1);
    this.setState({ colorsAdded: globalColors }, () => {
      this.props.pushGlobalColorArray(this.state.colorsAdded);
    });
    const preset = JSON.parse(JSON.stringify(this.state.presetAdded));
    preset.splice(index, 1);
    this.setState({ presetAdded: preset }, () => {
      this.props.pushGlobalColorPreset(this.state.presetAdded);
    });
  };

  toggleGlobalStyle = () => {
    this.setState((prevState) => ({
      globalModal: !prevState.globalModal,
    }));
    this.setState({
      colorsAdded: this.props.glblClrs,
      presetAdded: this.props.preset,
    });
  };

  deselectImage = () => {
    this.setState({
      bgImage: "",
      bgImageIndex: "",
    });
  };

  selectElementStyle = (e, element) => {
    const val = e.target.value;
    let name = e.target.name;
    name = name.split("-");
    let elementsFont = { ...this.props.canvasStyle.elementsFont };

    elementsFont[name[0]][name[1]] = val;
    this.props.pushElementFonts(elementsFont);
  };

  selectFont = (e) => {
    const font = e.target.value;
    this.setState({
      selectedOverrideFont: font,
      selectedFont: font,
    });
    this.props.pushOverrideFont(false);
    let selectedFont = JSON.parse(JSON.stringify(font));
    this.props.pushSelectedFont(selectedFont);
  };

  overrideCanvasStyle = (e) => {
    let overrideCanvasFont = { ...this.props.canvasStyle.overrideCanvasFont };
    overrideCanvasFont = e.target.checked;
    this.props.pushOverrideFont(overrideCanvasFont);

    if (this.props.selectedFont && e.target.checked) {
      this.formatTextAndSave("font-family", "*");
      let elementsFontObj = { ...this.props.canvasStyle.elementsFont };
      elementsFontKeysArray.map((item, index) => {
        elementsFontObj[item.name].font_family = this.props.selectedFont;
      });
      this.props.pushElementFonts(elementsFontObj);
    } else {
      // Do nothing
    }
  };

  selectElementTagBgColor = (bgColor, name1) => {
    let name = name1.split("-");
    let elementsFont = { ...this.props.canvasStyle.elementsFont };
    elementsFont[name[0]][name[1]] = bgColor.rgb;
    // elementsFont[name[0]][name[1]].a.toFixed(2)
    this.props.pushElementFonts(elementsFont);
  };

  // Width Checkbox
  widthOnChange(e) {
    if (e.target.value == "widthPixel") {
      this.setState(
        {
          containerWidth: 1200,
          pixel: true,
          percentage: false,
        },
        () => {
          let containerWidth = JSON.parse(
            JSON.stringify(this.state.containerWidth)
          );
          this.props.pushContainerWidth(containerWidth);
        }
      );
    } else if (e.target.value == "widthPercentage") {
      this.setState(
        {
          containerWidth: "100%",
          pixel: false,
          percentage: true,
        },
        () => {
          this.props.pushEnableWidthForRow(false);
          let containerWidth = JSON.parse(
            JSON.stringify(this.state.containerWidth)
          );
          this.props.pushContainerWidth(containerWidth);
        }
      );
    }
  }

  addImageBackground = (index) => {
    const selectedBGArray = JSON.parse(JSON.stringify(this.state.imagesGlobal));
    const selectedBG = selectedBGArray[index];

    this.setState({
      bgImage: selectedBG,
      bgImageIndex: index,
    });
  };

  counterValChange = (e) => {
    e.preventDefault();
    let val =
      e.target.value !== "" && e.target.value !== "0" && e.target.value !== "00"
        ? e.target.value.replace(/\b0+/g, "")
        : "0";
    if (val <= 1200) {
      this.setState(
        {
          pixelWidth: val,
        },
        () => {
          if (this.state.pixel == true) {
            let currentWidth = this.state.pixelWidth;
            this.setState(
              {
                containerWidth:
                  typeof currentWidth == "string"
                    ? JSON.parse(currentWidth)
                    : currentWidth,
              },
              () => {
                let containerWidth = JSON.parse(
                  JSON.stringify(this.state.containerWidth)
                );
                this.props.pushContainerWidth(containerWidth);
              }
            );
          }
        }
      );
    }
  };

  incrementWidth = () => {
    let counter = this.counter.value;
    if (this.state.pixelWidth < 1200) {
      this.setState(
        {
          pixelWidth:
            typeof this.state.pixelWidth == "string"
              ? JSON.parse(this.state.pixelWidth) + 1
              : this.state.pixelWidth + 1,
        },
        () => {
          if (this.state.pixel == true) {
            this.setState(
              {
                containerWidth:
                  typeof this.state.pixelWidth == "string"
                    ? JSON.parse(this.state.pixelWidth)
                    : this.state.pixelWidth,
              },
              () => {
                let containerWidth = JSON.parse(
                  JSON.stringify(this.state.containerWidth)
                );
                this.props.pushContainerWidth(containerWidth);
              }
            );
          }
        }
      );
    }
  };

  decrementWidth = () => {
    if (this.state.pixelWidth <= 1200) {
      this.setState(
        {
          pixelWidth:
            this.state.pixelWidth > 2 ? this.state.pixelWidth - 1 : "0",
        },
        () => {
          if (this.state.pixel == true) {
            this.setState(
              {
                containerWidth:
                  typeof this.state.pixelWidth == "string"
                    ? JSON.parse(this.state.pixelWidth)
                    : this.state.pixelWidth,
              },
              () => {
                let containerWidth = JSON.parse(
                  JSON.stringify(this.state.containerWidth)
                );
                this.props.pushContainerWidth(containerWidth);
              }
            );
          }
        }
      );
    }
  };

  getImageContent = (content) => {
    this.setState(
      {
        bgImage: content.image_thumb,
        bgImageId: content.image_id,
        bgType: "image",
        bgVideo: "",
        bgVideoId: "",
      },
      () => {
        this.props.pushBGimage(this.state.bgImage, this.state.bgImageId);
      }
    );
  };

  getContainerImageContent = (content) => {
    this.setState(
      {
        bgImageContainer: content.image_thumb,
        bgImageContainerId: content.image_id,
        bgType: "image",
        bgVideo: "",
        bgVideoId: "",
      },
      () => {
        this.props.pushBGContainerimage(
          this.state.bgImageContainer,
          this.state.bgImageContainerId
        );
      }
    );
  };

  getVideoContent = (content) => {
    this.setState({
      bgVideo: content.image,
      bgVideoId: content.id,
      bgType: "video",
      bgImage: "",
      bgImageId: "",
    });
  };

  removeBackgroundImage = () => {
    this.setState(
      {
        bgImage: "",
        bgImageId: "",
        bgVideo: "",
        bgImageContainer: "",
        bgImageContainerId: "",
        bgVideoId: "",
        bgType: "",
        bgColor: "#FFFFFF",
        surroundBg: { r: 252, g: 252, b: 252, a: 1 },
      },
      () => {
        this.props.pushBGimage(this.state.bgImage, this.state.bgImageId);
        this.props.pushBGVideo(this.state.bgVideo, this.state.bgVideoId);
        this.props.pushBGType("");
        this.props.pushBgColor("#FFFFFF");
        this.props.pushSurroundBg(this.state.surroundBg);
      }
    );
  };

  bgRepeat = (e) => {
    let valueToPush = e.target.checked ? "repeat" : "no-repeat";
    this.props.pushBgRepeat(valueToPush);
    let sizeToPush = e.target.checked ? "auto" : "auto";
    this.props.pushBgSize(sizeToPush);
  };

  bgSize = (e) => {
    this.props.pushBgRepeat("no-repeat");
    let valueToPush = e.target.checked ? "cover" : "auto";
    this.props.pushBgSize(valueToPush);
  };

  bgContainerRepeat = (e) => {
    let valueToPush = e.target.checked ? "repeat" : "no-repeat";
    this.props.pushBgContainerRepeat(valueToPush);
    let bgToPush = e.target.checked ? "auto" : "auto";
    this.props.pushBgContainerSize(bgToPush);
  };

  bgContainerSize = (e) => {
    this.props.pushBgContainerRepeat("no-repeat");
    let valueToPush = e.target.checked ? "cover" : "auto";
    this.props.pushBgContainerSize(valueToPush);
  };

  quickWidthOption = (e) => {
    this.setState(
      {
        containerWidth: e,
        pixelWidth: e,
        pixel: true,
        percentage: false,
      },
      () => {
        let containerWidth = JSON.parse(
          JSON.stringify(this.state.containerWidth)
        );
        this.props.pushContainerWidth(containerWidth);
      }
    );
  };

  convertBase64Image = (image, pushDataRedux) => {
    let base64ContentArray = image.split(",");
    let mimeType = image.match(/[^:\s*]\w+\/[\w-+\d.]+(?=[;| ])/)[0];
    let imageExt = mimeType.substr(mimeType.lastIndexOf("/") + 1);
    let base64Data = base64ContentArray[1];
    const data = {
      u: this.props.userID,
      sn: this.props.sessionID,
      tp: "base64",
      ext: imageExt,
      fullsize: base64Data,
    };
    Axios.MediaService.POST_MEDIA(data)
      .then((response) => {
        if (response.status == 200) {
          pushDataRedux(response.data.srcUrl, response.data.srcID);
        }
      })
      .catch((error) => {
        // Error
      });
  };

  cropandapplyCanvasImage = (image) => {
    this.convertBase64Image(image, this.props.pushBGimage);
  };

  setImageContainer = (image) => {
    this.convertBase64Image(image, this.props.pushBGContainerimage);
  };

  counterChange = (e, property, number) => {
    const selectedValue =
      e.target.value !== "" && e.target.value !== "0" && e.target.value !== "00"
        ? e.target.value.replace(/\b0+/g, "")
        : "0";
    const propertyVal = property;
    let propertyArray =
      Array.isArray(this.state[propertyVal]) === true
        ? [...this.state[propertyVal]]
        : this.state[propertyVal];
    if (typeof number === "number" && number >= 0) {
      propertyArray[number] = selectedValue;
    } else {
      propertyArray = selectedValue;
    }
    this.setState(
      {
        [propertyVal]: propertyArray,
      },
      () => {
        if (property === "canvasPadding") {
          this.props.pushCanvasPadding(this.state.canvasPadding);
        } else if (property === "canvasPaddingMobile") {
          this.props.pushCanvasPaddingMobile(this.state.canvasPaddingMobile);
        } else if (property === "canvasMargin") {
          this.props.pushCanvasMargin(this.state.canvasMargin);
        } else if (property === "canvasMarginMobile") {
          this.props.pushCanvasMarginMobile(this.state.canvasMarginMobile);
        } else if (property === "columnGap") {
          this.props.pushCanvasColumnGap(this.state.columnGap);
        } else if (property === "rowGap") {
          this.props.pushCanvasRowGap(this.state.rowGap);
        } else if (property === "canvasRowsPadding") {
          this.props.pushCanvasRowsPadding(this.state.canvasRowsPadding);
        } else if (property === "canvasRowsPaddingMobile") {
          this.props.pushCanvasRowsPaddingMobile(
            this.state.canvasRowsPaddingMobile
          );
        }
      }
    );
  };

  counterPlus = (value, property, number) => {
    const selectedValue = value;
    const propertyVal = property;
    let propertyArray =
      Array.isArray(this.state[propertyVal]) === true
        ? [...this.state[propertyVal]]
        : this.state[propertyVal];
    if (typeof number === "number" && number >= 0) {
      propertyArray[number] = JSON.parse(selectedValue) + 1;
    } else {
      propertyArray = JSON.parse(selectedValue) + 1;
    }
    this.setState(
      {
        [propertyVal]: propertyArray,
      },
      () => {
        if (property === "canvasPadding") {
          this.props.pushCanvasPadding(this.state.canvasPadding);
        } else if (property === "canvasPaddingMobile") {
          this.props.pushCanvasPaddingMobile(this.state.canvasPaddingMobile);
        } else if (property === "canvasMargin") {
          this.props.pushCanvasMargin(this.state.canvasMargin);
        } else if (property === "canvasMarginMobile") {
          this.props.pushCanvasMarginMobile(this.state.canvasMarginMobile);
        } else if (property === "columnGap") {
          this.props.pushCanvasColumnGap(this.state.columnGap);
        } else if (property === "rowGap") {
          this.props.pushCanvasRowGap(this.state.rowGap);
        } else if (property === "canvasRowsPadding") {
          this.props.pushCanvasRowsPadding(this.state.canvasRowsPadding);
        } else if (property === "canvasRowsPaddingMobile") {
          this.props.pushCanvasRowsPaddingMobile(
            this.state.canvasRowsPaddingMobile
          );
        }
      }
    );
  };

  counterMinus = (value, property, number) => {
    const selectedValue = value > 1 ? value : "1";
    const propertyVal = property;
    let propertyArray =
      Array.isArray(this.state[propertyVal]) === true
        ? [...this.state[propertyVal]]
        : this.state[propertyVal];
    if (typeof number === "number" && number >= 0) {
      propertyArray[number] = selectedValue - 1;
    } else {
      propertyArray = selectedValue - 1;
    }
    this.setState(
      {
        [propertyVal]: propertyArray,
      },
      () => {
        if (property === "canvasPadding") {
          this.props.pushCanvasPadding(this.state.canvasPadding);
        } else if (property === "canvasPaddingMobile") {
          this.props.pushCanvasPaddingMobile(this.state.canvasPaddingMobile);
        } else if (property === "canvasMargin") {
          this.props.pushCanvasMargin(this.state.canvasMargin);
        } else if (property === "canvasMarginMobile") {
          this.props.pushCanvasMarginMobile(this.state.canvasMarginMobile);
        } else if (property === "columnGap") {
          this.props.pushCanvasColumnGap(this.state.columnGap);
        } else if (property === "rowGap") {
          this.props.pushCanvasRowGap(this.state.rowGap);
        } else if (property === "canvasRowsPadding") {
          this.props.pushCanvasRowsPadding(this.state.canvasRowsPadding);
        } else if (property === "canvasRowsPaddingMobile") {
          this.props.pushCanvasRowsPaddingMobile(
            this.state.canvasRowsPaddingMobile
          );
        }
      }
    );
  };

  unitValueChange = (e, property) => {
    const selectedValue = e.target.value;
    this.setState(
      {
        [property]: selectedValue,
      },
      () => {
        if (property === "canvasPaddingUnit") {
          this.props.pushCanvasPaddingUnit(this.state.canvasPaddingUnit);
        } else if (property === "canvasMarginUnit") {
          this.props.pushCanvasMarginUnit(this.state.canvasMarginUnit);
        } else if (property === "canvasRowsPaddingUnit") {
          this.props.pushCanvasRowsPaddingUnit(
            this.state.canvasRowsPaddingUnit
          );
        }
      }
    );
  };

  spaceAfterCounterChange = (e, property, item) => {
    const selectedValue =
      e.target.value !== "" && e.target.value !== "0" && e.target.value !== "00"
        ? e.target.value.replace(/\b0+/g, "")
        : "0";
    const propertyVal = property;
    let elementsFont = { ...this.props.canvasStyle.elementsFont };
    elementsFont[item.name][propertyVal] = selectedValue;
    this.props.pushElementFonts(elementsFont);
  };

  spaceAfterCounterPlus = (value, property, item) => {
    const selectedValue = value;
    const propertyVal = property;
    let elementsFont = { ...this.props.canvasStyle.elementsFont };
    elementsFont[item.name][propertyVal] = JSON.parse(selectedValue) + 1;
    this.props.pushElementFonts(elementsFont);
  };

  spaceAfterCounterMinus = (value, property, item) => {
    const selectedValue = value > 1 ? value : "1";
    const propertyVal = property;
    let elementsFont = { ...this.props.canvasStyle.elementsFont };
    elementsFont[item.name][propertyVal] = selectedValue - 1;
    this.props.pushElementFonts(elementsFont);
  };

  resetMobileMargin = (e) => {
    const marginMobile = [0, 0];
    this.setState(
      {
        canvasMarginMobile: marginMobile,
      },
      () => {
        // this.props.pushCanvasMarginMobile(this.state.canvasMarginMobile)
      }
    );
  };

  resetMobilePadding = (e) => {
    const paddingMobile = [0, 0, 0, 0];
    this.setState(
      {
        canvasPaddingMobile: paddingMobile,
      },
      () => {
        //  this.props.pushCanvasPaddingMobile(this.state.canvasPaddingMobile)
      }
    );
  };

  resetMobileGap = (e) => {
    const rowGap = "0";
    this.setState(
      {
        rowGap: rowGap,
      },
      () => {
        // this.props.pushCanvasRowGap(this.state.rowGap)
      }
    );
  };

  resetStyle = (item) => {
    let elementsFont = { ...this.props.canvasStyle.elementsFont };
    elementsFont[item.name] = {
      ...globalTagsStyleObj,
      color: { r: 0, g: 0, b: 0, a: 1 },
      font_size:
        item.name == "h1"
          ? 40
          : item.name == "h2"
          ? 34
          : item.name == "h3"
          ? 24
          : item.name == "h4"
          ? 17
          : item.name == "p"
          ? 15
          : 12,
      font_family:
        item.name == "h1"
          ? "Montserrat"
          : item.name == "h2"
          ? "Montserrat"
          : item.name == "h3"
          ? "Montserrat"
          : item.name == "h4"
          ? "Montserrat"
          : item.name == "p"
          ? "Montserrat"
          : this.props.selectedFont,
      margin_bottom:
        item.name == "h1"
          ? 9
          : item.name == "h2"
          ? 8
          : item.name == "h3"
          ? 6
          : item.name == "h4"
          ? 6
          : item.name == "p"
          ? 12
          : 12,
      line_height:
        item.name == "h1"
          ? 1
          : item.name == "h2"
          ? 1
          : item.name == "h3"
          ? 1.1
          : item.name == "h4"
          ? 1.25
          : item.name == "p"
          ? 1.5
          : 1.5,
    };
    this.props.pushElementFonts(elementsFont);
  };

  getElementTag = (item) => {
    if (item.name == "div") {
      let node = React.createElement(
        item.name,
        {
          style: {
            fontFamily: this.state.overrideCanvasFont,
          },
        },
        `This is sample text.`
      );
      return node;
    } else {
      let node = React.createElement(
        item.name,
        {
          style: {
            fontFamily:
              this.props.canvasStyle.elementsFont[item.name] &&
              this.props.canvasStyle.elementsFont[item.name].font_family,
            fontSize:
              this.props.canvasStyle.elementsFont[item.name] &&
              this.props.canvasStyle.elementsFont[item.name].font_size
                ? UTILS.replacePX(
                    this.props.canvasStyle.elementsFont[item.name].font_size
                  ) + "px"
                : "",
            backgroundColor:
              this.props.canvasStyle.elementsFont[item.name] &&
              this.props.canvasStyle.elementsFont[item.name].background_color
                ? `rgba(${
                    this.props.canvasStyle.elementsFont[item.name]
                      .background_color.r
                  },
          ${this.props.canvasStyle.elementsFont[item.name].background_color.g},
          ${this.props.canvasStyle.elementsFont[item.name].background_color.b},
          ${this.props.canvasStyle.elementsFont[item.name].background_color.a})`
                : "",
            //display: "inline",
            color:
              this.props.canvasStyle.elementsFont[item.name] &&
              this.props.canvasStyle.elementsFont[item.name].color
                ? `rgba(${
                    this.props.canvasStyle.elementsFont[item.name].color.r
                  },
          ${this.props.canvasStyle.elementsFont[item.name].color.g},
          ${this.props.canvasStyle.elementsFont[item.name].color.b},
          ${this.props.canvasStyle.elementsFont[item.name].color.a})`
                : "#000",
            fontStyle:
              this.props.canvasStyle.elementsFont[item.name] &&
              this.props.canvasStyle.elementsFont[item.name].font_style,
            // fontWeight:
            //   this.props.canvasStyle.elementsFont[item.name] &&
            //   this.props.canvasStyle.elementsFont[item.name].font_weight,
            // textDecoration:
            //   this.props.canvasStyle.elementsFont[item.name] &&
            //   this.props.canvasStyle.elementsFont[item.name].text_decoration,
          },
        },
        `This is sample text.`
      );
      return node;
    }
  };

  toggleElementTags = (e) => {
    let event = e.target.dataset.event;
    this.setState({
      collapse: this.state.collapse === Number(event) ? 0 : Number(event),
    });
  };

  overrideButton = () => {
    // Remove all fonts
    this.formatTextAndSave("font-family", "*");
    // Add font for all elements
    let elementsFontObj = { ...this.props.canvasStyle.elementsFont };
    elementsFontKeysArray.map((item, index) => {
      elementsFontObj[item.name].font_family = this.props.selectedFont;
    });
    this.props.pushElementFonts(elementsFontObj);
    // Push selected font
    let selectedFont = JSON.parse(
      JSON.stringify(this.state.selectedOverrideFont)
    );
    this.props.pushSelectedFont(selectedFont);
  };

  render() {
    const { collapse } = this.state;
    // let counter = this.counter.value;

    const styles = reactCSS({
      default: {
        color: {
          width: "36px",
          height: "14px",
          borderRadius: "2px",
          background: this.state.color,
        },
        swatch: {
          padding: "5px",
          background: "#fff",
          borderRadius: "1px",
          boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
          display: "inline-block",
          cursor: "pointer",
        },
        popover: {
          position: "absolute",
          zIndex: "2",
          top: "40px",
        },
        cover: {
          position: "fixed",
          top: "0px",
          right: "0px",
          bottom: "0px",
          left: "0px",
        },
      },
    });

    let globalColorsPalette = (
      <div className="pre-defined-global-color">
        {this.state.colorsAdded.map((color, index) => {
          return (
            <div className="global-color-block" key={`${index} globalColors`}>
              <span
                className="block"
                style={{
                  background: `rgba(${color.rgb.r},${color.rgb.g},${
                    color.rgb.b
                  },${color.rgb.a || 1})`,
                }}
              />
              <p>
                <strong>Hex:</strong> {color.hex}
              </p>

              <p>
                <span className="red">
                  <strong>R:</strong>{" "}
                </span>{" "}
                {color.rgb.r}
                {"   "}
                <span className="green">
                  <strong>G:</strong>{" "}
                </span>{" "}
                {color.rgb.g}
                {"   "}
                <span className="blue">
                  <strong>B:</strong>{" "}
                </span>{" "}
                {color.rgb.b}
                {"   "}
                <span className="black">
                  <strong>A:</strong>{" "}
                </span>{" "}
                {color.rgb.a || 1}
              </p>
              <Confirm
                title="Delete Color"
                confirmMessage="Are you sure you want to delete this color from the palette?"
                classList="deleteColor"
                element="button"
                getConfirmation={(status) => {
                  status && this.deleteColor(index);
                }}
              >
                <svg width="15.928" height="17.531" viewBox="0 0 15.928 17.531">
                  <g id="trash" transform="translate(-2.25 -1.25)">
                    <path
                      id="Path_391"
                      data-name="Path 391"
                      d="M3,6H17.428"
                      transform="translate(0 -0.794)"
                      fill="none"
                      stroke="#0c3254"
                      strokeLinecap="square"
                      strokeWidth="1.5"
                    />
                    <path
                      id="Path_392"
                      data-name="Path 392"
                      d="M16.222,5.206V16.428a1.6,1.6,0,0,1-1.6,1.6H6.6a1.6,1.6,0,0,1-1.6-1.6V5.206m2.4,0V3.6A1.6,1.6,0,0,1,9.008,2h3.206a1.6,1.6,0,0,1,1.6,1.6v1.6"
                      transform="translate(-0.397 0)"
                      fill="none"
                      stroke="#0c3254"
                      strokeLinecap="square"
                      strokeWidth="1.5"
                    />
                    <path
                      id="Path_395"
                      data-name="Path 395"
                      d="M0,0V4.809"
                      transform="translate(8.611 9.214)"
                      fill="none"
                      stroke="#0c3254"
                      strokeLinecap="square"
                      strokeWidth="1.5"
                    />
                    <path
                      id="Path_394"
                      data-name="Path 394"
                      d="M0,0V4.809"
                      transform="translate(11.817 9.214)"
                      fill="none"
                      stroke="#0c3254"
                      strokeLinecap="square"
                      strokeWidth="1.5"
                    />
                  </g>
                </svg>
              </Confirm>
            </div>
          );
        })}
      </div>
    );

    const fonts = (
      <div className="selectFontWrapper">
        <select
          defaultValue={this.props.selectedFont}
          className="selectFont"
          onChange={(e) => {
            this.selectFont(e);
          }}
        >
          {this.props.googleFonts.map((font, index) => (
            <option
              style={{ fontFamily: font.format }}
              key={`${index} format`}
              value={font.format}
            >
              {font.name}
            </option>
          ))}
        </select>
      </div>
    );

    return (
      <Popup
        width="700"
        header="Global Style Settings"
        closePopup={this.props.closeModal}
        close={this.props.closeModal}
      >
        <div className="styleMain">
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "1",
                })}
                onClick={() => {
                  this.toggle("1");
                }}
              >
                Background
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "2",
                })}
                onClick={() => {
                  this.toggle("2");
                }}
              >
                Typography
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "3",
                })}
                onClick={() => {
                  this.toggle("3");
                }}
              >
                Structure
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "4",
                })}
                onClick={() => {
                  this.toggle("4");
                }}
              >
                Color Palette
              </NavLink>
            </NavItem>
          </Nav>

          <div className="modalScrollContainer">
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <div className="">
                  <div
                    className="padding-section"
                    style={{ marginTop: "10px", marginBottom: "20px" }}
                  >
                    <div className="heading">Canvas Background</div>
                  </div>
                  <div></div>
                  <div className="modalContentWrapper">
                    <div style={{ width: "300px", paddingLeft: 0 }}>
                      <ColorPicker
                        btnLabel="Canvas Background Color"
                        colorValue={this.state.bgColor}
                        colorDefaultValue={{
                          r: 252,
                          g: 252,
                          b: 252,
                          a: 1,
                        }}
                        getColor={(e) => {
                          this.bgColorhandleChange(e);
                        }}
                      />
                    </div>
                    <div className="libraryContent selectVideo">
                      <TabContent>
                        <TabPane>
                          <button
                            className="select-various-content-button"
                            onClick={() => {
                              this.setState({
                                library: !this.state.library,
                              });
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="17.8"
                              height="17.8"
                              viewBox="0 0 17.8 17.8"
                            >
                              <g id="image" transform="translate(-0.6 -2.1)">
                                <rect
                                  id="Rectangle_733"
                                  data-name="Rectangle 733"
                                  width="16"
                                  height="16"
                                  rx="2"
                                  transform="translate(1.5 3)"
                                  fill="none"
                                  stroke="#0c3254"
                                  strokeLinecap="square"
                                  strokeWidth="1.8"
                                />
                                <circle
                                  id="Ellipse_10"
                                  data-name="Ellipse 10"
                                  cx="1.5"
                                  cy="1.5"
                                  r="1.5"
                                  transform="translate(4.467 6.467)"
                                  fill="none"
                                  stroke="#0c3254"
                                  strokeLinecap="square"
                                  strokeWidth="1.8"
                                />
                                <path
                                  id="Path_348"
                                  data-name="Path 348"
                                  d="M18.4,14.5,14.537,10,4,20"
                                  transform="translate(-2 -2)"
                                  fill="none"
                                  stroke="#0c3254"
                                  strokeLinecap="square"
                                  strokeWidth="1.8"
                                />
                              </g>
                            </svg>
                            {this.props.bgImage ? "Change" : "Add"} Canvas
                            Background Image
                          </button>
         
                          {this.props.bgImage ? (
                            <Fragment>
                              <button
                                onClick={() => {
                                  this.setState({
                                    canvasSetting: !this.state.canvasSetting,
                                  });
                                }}
                                className={
                                  "deleteBackgroundIcon settingBackground " +
                                  (this.state.canvasSetting ? " active" : " ")
                                }
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="19.455"
                                  height="20.001"
                                  viewBox="0 0 19.455 20.001"
                                >
                                  <path
                                    id="Icon"
                                    d="M216,440h-4a.488.488,0,0,1-.49-.42l-.38-2.65a7.376,7.376,0,0,1-1.69-.98l-2.49,1a.467.467,0,0,1-.169.03.5.5,0,0,1-.44-.25l-2-3.46a.5.5,0,0,1,.121-.64l2.11-1.65a8.111,8.111,0,0,1-.07-.98,7.937,7.937,0,0,1,.07-.98l-2.11-1.651a.491.491,0,0,1-.121-.64l2-3.46a.492.492,0,0,1,.429-.25.569.569,0,0,1,.18.03l2.49,1a7.645,7.645,0,0,1,1.69-.979l.38-2.65A.488.488,0,0,1,212,420h4a.488.488,0,0,1,.49.42l.381,2.651a7.361,7.361,0,0,1,1.689.979l2.49-1a.471.471,0,0,1,.17-.03.5.5,0,0,1,.44.25l2,3.46a.5.5,0,0,1-.12.64l-2.111,1.651a6.876,6.876,0,0,1,0,1.96l2.111,1.65a.5.5,0,0,1,.12.64l-2,3.46a.493.493,0,0,1-.43.25.57.57,0,0,1-.18-.03l-2.49-1a7.634,7.634,0,0,1-1.689.98l-.381,2.65A.488.488,0,0,1,216,440Zm-6.25-6.32h0l.91.7a5.669,5.669,0,0,0,1.229.71l1.06.43.16,1.13L213.3,438h1.4l.2-1.351.16-1.13,1.059-.43a5.836,5.836,0,0,0,1.25-.73l.9-.68,1.04.419,1.27.51.7-1.211-1.08-.84-.89-.7.139-1.13c.029-.281.05-.513.05-.73a5.236,5.236,0,0,0-.05-.73l-.139-1.13.89-.7,1.069-.85-.7-1.211-1.27.51-1.06.43-.91-.7a5.681,5.681,0,0,0-1.23-.71l-1.06-.43-.16-1.13-.19-1.35H213.3l-.2,1.35-.16,1.13-1.06.43a5.853,5.853,0,0,0-1.25.73l-.9.68-1.04-.42-1.27-.51-.7,1.211,1.08.84.89.7-.14,1.13c-.031.316-.049.537-.049.73s.021.446.049.74l.14,1.13-.89.7-1.08.841.7,1.21,1.27-.51,1.059-.429ZM214,434a4,4,0,1,1,4-4A4,4,0,0,1,214,434Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,214,428Z"
                                    transform="translate(-204.271 -419.999)"
                                    fill="#0c3254"
                                  />
                                </svg>
                              </button>
                              <button
                                onClick={() => {
                                  const img = "";
                                  this.props.pushBGimage(img, img);
                                }}
                                className="deleteBackgroundIcon"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                >
                                  <g
                                    id="delete"
                                    transform="translate(34.5 5.5)"
                                  >
                                    <g
                                      id="trash"
                                      transform="translate(-32.5 -3.5)"
                                    >
                                      <path
                                        id="Path_363"
                                        data-name="Path 363"
                                        d="M3,6H16.539"
                                        transform="translate(0 -0.991)"
                                        fill="none"
                                        stroke="#0c3254"
                                        strokeLinecap="square"
                                        strokeWidth="1.3"
                                      />
                                      <path
                                        id="Path_364"
                                        data-name="Path 364"
                                        d="M15.53,5.009v10.53a1.5,1.5,0,0,1-1.5,1.5H6.5a1.5,1.5,0,0,1-1.5-1.5V5.009m2.257,0V3.5A1.5,1.5,0,0,1,8.761,2H11.77a1.5,1.5,0,0,1,1.5,1.5v1.5"
                                        transform="translate(-0.496)"
                                        fill="none"
                                        stroke="#0c3254"
                                        strokeLinecap="square"
                                        strokeWidth="1.3"
                                      />
                                      <line
                                        id="Line_64"
                                        data-name="Line 64"
                                        y2="4.513"
                                        transform="translate(8.265 8.77)"
                                        fill="none"
                                        stroke="#0c3254"
                                        strokeLinecap="square"
                                        strokeWidth="1.3"
                                      />
                                      <line
                                        id="Line_65"
                                        data-name="Line 65"
                                        y2="4.513"
                                        transform="translate(11.274 8.77)"
                                        fill="none"
                                        stroke="#0c3254"
                                        strokeLinecap="square"
                                        strokeWidth="1.3"
                                      />
                                    </g>
                                  </g>
                                </svg>
                              </button>
                            </Fragment>
                          ) : null}
                          {this.props.bgImage && this.state.canvasSetting ? (
                            <Fragment>
                              <BackgroundImageControl
                                bgImage={
                                  this.props.bgImage ? this.props.bgImage : ""
                                }
                                bgRepeatChange={this.bgRepeat}
                                bgRepeat={
                                  this.props.bgRepeat
                                    ? this.props.bgRepeat
                                    : "no-repeat"
                                }
                                bgSizeChange={this.bgSize}
                                bgSize={
                                  this.props.bgSize ? this.props.bgSize : "auto"
                                }
                                size="backgroundSize"
                                repeat="backgroundRepeat"
                              />
                            </Fragment>
                          ) : null}

                          <Row>
                            {this.state.library ? (
                              <ImagesContent
                                userID={this.props.userID}
                                sessionID={this.props.sessionID}
                                modalUpload={this.props.modalUpload}
                                ID={this.props.ID}
                                selectingContent={true}
                                chooseImageForParent={this.getImageContent}
                                forParentContent={true}
                                closeImageLibrary={() => {
                                  this.setState({
                                    library: !this.state.library,
                                  });
                                }}
                                initP={this.props.initP}
                                addImage={this.props.addImage}
                                opacity={this.props.opacity}
                                radius={this.props.radius}
                                float={this.props.float}
                              />
                            ) : null}
                          </Row>
                          <div className="clearfix"></div>

                          <div className="clearfix"></div>
                        </TabPane>
                      </TabContent>
                    </div>
                  </div>

                  <div sm="12" style={{ marginBottom: "20px" }}>
                    <div
                      className="padding-section"
                      style={{ marginBottom: "20px" }}
                    >
                      <div className="heading">Container Background</div>
                    </div>
                  </div>
                  <div className="modalContentWrapper">
                    <div style={{ width: "300px", paddingLeft: 0 }}>
                      <ColorPicker
                        btnLabel="Container Background Color"
                        colorValue={this.state.surroundBg}
                        colorDefaultValue={{
                          r: 252,
                          g: 252,
                          b: 252,
                          a: 1,
                        }}
                        getColor={(e) => {
                          this.surroundBgColorhandleChange(e);
                        }}
                      />
                    </div>

                    <div className="libraryContent selectVideo">
                      <TabContent>
                        <TabPane>
                          <div className="clearfix"></div>

                          <button
                            className="select-various-content-button"
                            onClick={() => {
                              this.setState({
                                libraryContainer: !this.state.libraryContainer,
                              });
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="17.8"
                              height="17.8"
                              viewBox="0 0 17.8 17.8"
                            >
                              <g id="image" transform="translate(-0.6 -2.1)">
                                <rect
                                  id="Rectangle_733"
                                  data-name="Rectangle 733"
                                  width="16"
                                  height="16"
                                  rx="2"
                                  transform="translate(1.5 3)"
                                  fill="none"
                                  stroke="#0c3254"
                                  strokeLinecap="square"
                                  strokeWidth="1.8"
                                />
                                <circle
                                  id="Ellipse_10"
                                  data-name="Ellipse 10"
                                  cx="1.5"
                                  cy="1.5"
                                  r="1.5"
                                  transform="translate(4.467 6.467)"
                                  fill="none"
                                  stroke="#0c3254"
                                  strokeLinecap="square"
                                  strokeWidth="1.8"
                                />
                                <path
                                  id="Path_348"
                                  data-name="Path 348"
                                  d="M18.4,14.5,14.537,10,4,20"
                                  transform="translate(-2 -2)"
                                  fill="none"
                                  stroke="#0c3254"
                                  strokeLinecap="square"
                                  strokeWidth="1.8"
                                />
                              </g>
                            </svg>
                            {this.props.bgImageContainer ? "Change" : "Add"}{" "}
                            Container Background Image
                          </button>

                          {this.props.bgImageContainer ? (
                            <Fragment>
                              <button
                                onClick={() => {
                                  this.setState({
                                    containerSetting:
                                      !this.state.containerSetting,
                                  });
                                }}
                                className={
                                  "deleteBackgroundIcon settingBackground " +
                                  (this.state.containerSetting ? "active" : " ")
                                }
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="19.455"
                                  height="20.001"
                                  viewBox="0 0 19.455 20.001"
                                >
                                  <path
                                    id="Icon"
                                    d="M216,440h-4a.488.488,0,0,1-.49-.42l-.38-2.65a7.376,7.376,0,0,1-1.69-.98l-2.49,1a.467.467,0,0,1-.169.03.5.5,0,0,1-.44-.25l-2-3.46a.5.5,0,0,1,.121-.64l2.11-1.65a8.111,8.111,0,0,1-.07-.98,7.937,7.937,0,0,1,.07-.98l-2.11-1.651a.491.491,0,0,1-.121-.64l2-3.46a.492.492,0,0,1,.429-.25.569.569,0,0,1,.18.03l2.49,1a7.645,7.645,0,0,1,1.69-.979l.38-2.65A.488.488,0,0,1,212,420h4a.488.488,0,0,1,.49.42l.381,2.651a7.361,7.361,0,0,1,1.689.979l2.49-1a.471.471,0,0,1,.17-.03.5.5,0,0,1,.44.25l2,3.46a.5.5,0,0,1-.12.64l-2.111,1.651a6.876,6.876,0,0,1,0,1.96l2.111,1.65a.5.5,0,0,1,.12.64l-2,3.46a.493.493,0,0,1-.43.25.57.57,0,0,1-.18-.03l-2.49-1a7.634,7.634,0,0,1-1.689.98l-.381,2.65A.488.488,0,0,1,216,440Zm-6.25-6.32h0l.91.7a5.669,5.669,0,0,0,1.229.71l1.06.43.16,1.13L213.3,438h1.4l.2-1.351.16-1.13,1.059-.43a5.836,5.836,0,0,0,1.25-.73l.9-.68,1.04.419,1.27.51.7-1.211-1.08-.84-.89-.7.139-1.13c.029-.281.05-.513.05-.73a5.236,5.236,0,0,0-.05-.73l-.139-1.13.89-.7,1.069-.85-.7-1.211-1.27.51-1.06.43-.91-.7a5.681,5.681,0,0,0-1.23-.71l-1.06-.43-.16-1.13-.19-1.35H213.3l-.2,1.35-.16,1.13-1.06.43a5.853,5.853,0,0,0-1.25.73l-.9.68-1.04-.42-1.27-.51-.7,1.211,1.08.84.89.7-.14,1.13c-.031.316-.049.537-.049.73s.021.446.049.74l.14,1.13-.89.7-1.08.841.7,1.21,1.27-.51,1.059-.429ZM214,434a4,4,0,1,1,4-4A4,4,0,0,1,214,434Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,214,428Z"
                                    transform="translate(-204.271 -419.999)"
                                    fill="#0c3254"
                                  />
                                </svg>
                              </button>
                              <button
                                onClick={() => {
                                  const img = "";
                                  this.setState(
                                    {
                                      bgImageContainer: "",
                                      bgImageContainerId: "",
                                    },
                                    () => {
                                      this.props.pushBGContainerimage(img, img);
                                    }
                                  );
                                }}
                                className="deleteBackgroundIcon"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                >
                                  <g
                                    id="delete"
                                    transform="translate(34.5 5.5)"
                                  >
                                    <g
                                      id="trash"
                                      transform="translate(-32.5 -3.5)"
                                    >
                                      <path
                                        id="Path_363"
                                        data-name="Path 363"
                                        d="M3,6H16.539"
                                        transform="translate(0 -0.991)"
                                        fill="none"
                                        stroke="#0c3254"
                                        strokeLinecap="square"
                                        strokeWidth="1.3"
                                      />
                                      <path
                                        id="Path_364"
                                        data-name="Path 364"
                                        d="M15.53,5.009v10.53a1.5,1.5,0,0,1-1.5,1.5H6.5a1.5,1.5,0,0,1-1.5-1.5V5.009m2.257,0V3.5A1.5,1.5,0,0,1,8.761,2H11.77a1.5,1.5,0,0,1,1.5,1.5v1.5"
                                        transform="translate(-0.496)"
                                        fill="none"
                                        stroke="#0c3254"
                                        strokeLinecap="square"
                                        strokeWidth="1.3"
                                      />
                                      <line
                                        id="Line_64"
                                        data-name="Line 64"
                                        y2="4.513"
                                        transform="translate(8.265 8.77)"
                                        fill="none"
                                        stroke="#0c3254"
                                        strokeLinecap="square"
                                        strokeWidth="1.3"
                                      />
                                      <line
                                        id="Line_65"
                                        data-name="Line 65"
                                        y2="4.513"
                                        transform="translate(11.274 8.77)"
                                        fill="none"
                                        stroke="#0c3254"
                                        strokeLinecap="square"
                                        strokeWidth="1.3"
                                      />
                                    </g>
                                  </g>
                                </svg>
                              </button>
                            </Fragment>
                          ) : null}
                          <div className="clearfix"></div>

                          {this.props.bgImageContainer &&
                          this.state.containerSetting ? (
                            <Fragment>
                              <BackgroundImageControl
                                bgImage={
                                  this.props.bgImageContainer
                                    ? this.props.bgImageContainer
                                    : ""
                                }
                                bgRepeatChange={this.bgContainerRepeat}
                                bgRepeat={
                                  this.props.bgContainerRepeat
                                    ? this.props.bgContainerRepeat
                                    : "no-repeat"
                                }
                                bgSizeChange={this.bgContainerSize}
                                bgSize={
                                  this.props.bgContainerSize
                                    ? this.props.bgContainerSize
                                    : "auto"
                                }
                                size="backgroundSizeContainer"
                                repeat="backgroundRepeatContainer"
                              />
                            </Fragment>
                          ) : null}

                          <Row>
                            <Col className="videoContentDIV">
                              {this.state.libraryContainer ? (
                                <ImagesContent
                                  userID={this.props.userID}
                                  sessionID={this.props.sessionID}
                                  modalUpload={this.props.modalUpload}
                                  selectingContent={true}
                                  ID={this.props.ID}
                                  chooseImageForParent={
                                    this.getContainerImageContent
                                  }
                                  forParentContent={true}
                                  closeImageLibrary={() => {
                                    this.setState({
                                      libraryContainer:
                                        !this.state.libraryContainer,
                                    });
                                  }}
                                  initP={this.props.initP}
                                  addImage={this.props.addImage}
                                  opacity={this.props.opacity}
                                  radius={this.props.radius}
                                  float={this.props.float}
                                />
                              ) : null}
                            </Col>
                          </Row>
                        </TabPane>
                      </TabContent>
                    </div>
                  </div>
                </div>
              </TabPane>
              <TabPane className="" tabId="2">
                <div className="modalContentWrapper">
                  <div
                    style={{
                      fontSize: "22px",
                      fontFamily: this.props.selectedFont,
                      margin: "10px",
                    }}
                  >
                    This is Sample Text
                  </div>
                  <div
                    style={{ display: "flex", flexDirection: "row" }}
                    className="font-family"
                  >
                    <Col sm="6" className="selectFontWrapperParent">
                      <label>Default Font Family</label>
                      <div className="form-group">{fonts}</div>
                    </Col>
                    <Col sm="6" className="selectFontWrapperParent">
                      <button
                        className="overrideButtonAll"
                        onClick={this.overrideButton}
                      >
                        <div>Override All Font Families</div>
                        <small>(Global and Local Override)</small>
                      </button>
                    </Col>
                  </div>
                </div>

                {elementsFontKeysArray &&
                  elementsFontKeysArray.map((item, index) => (
                    <Row
                      key={`styles-for-tags-${index}`}
                      className="font-family"
                      style={{ margin: 0 }}
                    >
                      {/* <Col sm="12" className="devider ml-0 "></Col> */}

                      <div
                        className="heading-row heading-row-fontfamily"
                        onClick={this.toggleElementTags}
                        data-event={item.tagNum}
                      >
                        <div className="heading">Styles for {item.label}</div>
                        {collapse === item.tagNum && (
                          <i
                            className="fa fa-angle-up"
                            aria-hidden="true"
                            data-event={item.tagNum}
                          ></i>
                        )}
                        {collapse !== item.tagNum && (
                          <i
                            className="fa fa-angle-down"
                            aria-hidden="true"
                            data-event={item.tagNum}
                          ></i>
                        )}
                      </div>
                      <Collapse
                        style={{ paddingLeft: "20px" }}
                        isOpen={collapse === item.tagNum}
                      >
                        <Col lg="12" className="selectFontWrapperParent">
                          {this.getElementTag(item)}
                        </Col>
                        <Col sm="5" className="selectFontWrapperParent">
                          <label>Font Family</label>
                          <div className="form-group">
                            <div className="selectFontWrapper">
                              <select
                                className="selectFontFamily"
                                type="text"
                                name={`${item.name}-font_family`}
                                placeholder="Select Font Family"
                                list={`data-font_family-${index}`}
                                value={
                                  this.props.canvasStyle.elementsFont[item.name]
                                    .font_family
                                   
                                }
                                // onFocus={(e) => (e.target.value = "")}
                                onBlur={(e) => {
                                  let fontValue = e.target.value;
                                  fontValue = this.props.canvasStyle
                                    .elementsFont[item.name].font_family
                                    ? this.props.canvasStyle.elementsFont[
                                        item.name
                                      ].font_family
                                    : null;
                                }}
                                onChange={(e) => {
                                  // item.name == "p" ? this.formatTextAndSave('font-family', 'p'):null;
                                  //   item.name == "h1" ? this.formatTextAndSave('font-family', 'h1'):null;
                                  //   item.name == "h2" ? this.formatTextAndSave('font-family', 'h2'):null;
                                  //   item.name == "h3" ? this.formatTextAndSave('font-family', 'h3'):null;
                                  //   item.name == "h4" ? this.formatTextAndSave('font-family', 'h4'):null;
                                  //   item.name == "h5" ? this.formatTextAndSave('font-family', 'h5'):null;
                                  //   item.name == "h6" ? this.formatTextAndSave('font-family', 'h6'):null;
                                  this.selectElementStyle(e, item.name);
                                }}
                              >
                                {/* <datalist id={`data-font_family-${index}`}> */}
                                {this.props.googleFonts.map((font, index) => {
                                  return (
                                    <option
                                      key={`${index} fonts`}
                                      value={font.format}
                                    >
                                      {font.name}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                          <div className="clearfix"></div>
                        </Col>

                        <div>
                          <Counter
                            label="Font Size"
                            style={{ marginRight: "0px !important" }}
                            //small="Top & Bottom - Desktop"
                            onBlurAction={() => {
                              // item.name == "p" ? this.formatTextAndSave('font-size', 'p'):null;
                              //       item.name == "h1" ? this.formatTextAndSave('font-size', 'h1'):null;
                              //       item.name == "h2" ? this.formatTextAndSave('font-size', 'h2'):null;
                              //       item.name == "h3" ? this.formatTextAndSave('font-size', 'h3'):null;
                              //       item.name == "h4" ? this.formatTextAndSave('font-size', 'h4'):null;
                              //       item.name == "h5" ? this.formatTextAndSave('font-size', 'h5'):null;
                              //       item.name == "h6" ? this.formatTextAndSave('font-size', 'h6'):null;
                            }}
                            minusClick={() =>
                              this.spaceAfterCounterMinus(
                                this.props.canvasStyle &&
                                  this.props.canvasStyle.elementsFont &&
                                  this.props.canvasStyle.elementsFont[
                                    item.name
                                  ] &&
                                  this.props.canvasStyle.elementsFont[item.name]
                                    .font_size
                                  ? UTILS.replacePX(
                                      this.props.canvasStyle.elementsFont[
                                        item.name
                                      ].font_size
                                    )
                                  : item.fontSize,
                                "font_size",
                                item
                              )
                            }
                            valueContent={
                              this.props.canvasStyle &&
                              this.props.canvasStyle.elementsFont &&
                              this.props.canvasStyle.elementsFont[item.name] &&
                              this.props.canvasStyle.elementsFont[item.name]
                                .font_size
                                ? UTILS.replacePX(
                                    this.props.canvasStyle.elementsFont[
                                      item.name
                                    ].font_size
                                  )
                                : item.fontSize
                            }
                            disabled={false}
                            onChange={(e) => {
                              this.spaceAfterCounterChange(
                                e,
                                "font_size",
                                item
                              );
                            }}
                            plusClick={() =>
                              this.spaceAfterCounterPlus(
                                this.props.canvasStyle &&
                                  this.props.canvasStyle.elementsFont &&
                                  this.props.canvasStyle.elementsFont[
                                    item.name
                                  ] &&
                                  this.props.canvasStyle.elementsFont[item.name]
                                    .font_size
                                  ? UTILS.replacePX(
                                      this.props.canvasStyle.elementsFont[
                                        item.name
                                      ].font_size
                                    )
                                  : item.fontSize,
                                "font_size",
                                item
                              )
                            }
                          />

                          <div className="clearfix"></div>
                        </div>
                        <Col
                          style={{ float: "left" }}
                          sm="4"
                          className="selectFontWrapperParent"
                        >
                          <label>Line Height</label>
                          <div className="form-group">
                            <div className="selectFontWrapper">
                              <input
                                className="selectFont"
                                type="text"
                                name={`${item.name}-line_height`}
                                placeholder="Select Line Height"
                                list={`data-line_height-${index}`}
                                value={
                                  this.props.canvasStyle.elementsFont[item.name]
                                    .line_height
                                    ? this.props.canvasStyle.elementsFont[
                                        item.name
                                      ].line_height
                                    : ""
                                }
                                onFocus={(e) => (e.target.value = "")}
                                onBlur={(e) => {
                                  let fontValue = e.target.value;
                                  fontValue =
                                    this.props.canvasStyle &&
                                    this.props.canvasStyle.elementsFont &&
                                    this.props.canvasStyle.elementsFont[
                                      item.name
                                    ] &&
                                    this.props.canvasStyle.elementsFont[
                                      item.name
                                    ].line_height
                                      ? this.props.canvasStyle.elementsFont[
                                          item.name
                                        ].line_height
                                      : null;
                                  // item.name == "p" ? this.formatTextAndSave('line-height', 'p'):null;
                                  // item.name == "h1" ? this.formatTextAndSave('line-height', 'h1'):null;
                                  // item.name == "h2" ? this.formatTextAndSave('line-height', 'h2'):null;
                                  // item.name == "h3" ? this.formatTextAndSave('line-height', 'h3'):null;
                                  // item.name == "h4" ? this.formatTextAndSave('line-height', 'h4'):null;
                                  // item.name == "h5" ? this.formatTextAndSave('line-height', 'h5'):null;
                                  // item.name == "h6" ? this.formatTextAndSave('line-height', 'h6'):null;
                                }}
                                onChange={(e) => {
                                  this.selectElementStyle(e, item.name);
                                }}
                              />

                              <datalist id={`data-line_height-${index}`}>
                                {lineheight_formats &&
                                  lineheight_formats.map((fontSize, index) => {
                                    return (
                                      <option
                                        key={`${index} lineheight`}
                                        value={fontSize}
                                      >
                                        {fontSize}
                                      </option>
                                    );
                                  })}
                              </datalist>
                            </div>
                          </div>
                          <div className="clearfix"></div>
                        </Col>

                        <Col
                          sm="5"
                          className="buttons bgColorOptions"
                          // style={{ width: "100%" }}
                        >
                          <label></label>
                          <ColorPicker
                            disableAlpha={true}
                            onBlurAction={() => {
                              // item.name == "p" ? this.formatTextAndSave('color', 'p'):null;
                              //       item.name == "h1" ? this.formatTextAndSave('color', 'h1'):null;
                              //       item.name == "h2" ? this.formatTextAndSave('color', 'h2'):null;
                              //       item.name == "h3" ? this.formatTextAndSave('color', 'h3'):null;
                              //       item.name == "h4" ? this.formatTextAndSave('color', 'h4'):null;
                              //       item.name == "h5" ? this.formatTextAndSave('color', 'h5'):null;
                              //       item.name == "h6" ? this.formatTextAndSave('color', 'h6'):null;
                            }}
                            btnLabel="Text Color"
                            colorValue={
                              this.props.canvasStyle &&
                              this.props.canvasStyle.elementsFont &&
                              this.props.canvasStyle.elementsFont[item.name] &&
                              this.props.canvasStyle.elementsFont[item.name]
                                .color
                            }
                            colorDefaultValue="Choose color"
                            getColor={(e) => {
                              this.selectElementTagBgColor(
                                e,
                                `${item.name}-color`
                              );
                            }}
                          />
                        </Col>

                        <div
                          className=""
                          style={{
                            paddingTop: "15px",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Counter
                            label="Space After"
                            // small="Top & Bottom - Desktop"
                            minusClick={() =>
                              this.spaceAfterCounterMinus(
                                this.props.canvasStyle &&
                                  this.props.canvasStyle.elementsFont &&
                                  this.props.canvasStyle.elementsFont[
                                    item.name
                                  ] &&
                                  this.props.canvasStyle.elementsFont[item.name]
                                    .margin_bottom
                                  ? this.props.canvasStyle.elementsFont[
                                      item.name
                                    ].margin_bottom
                                  : "0",
                                "margin_bottom",
                                item
                              )
                            }
                            valueContent={
                              this.props.canvasStyle &&
                              this.props.canvasStyle.elementsFont &&
                              this.props.canvasStyle.elementsFont[item.name] &&
                              this.props.canvasStyle.elementsFont[item.name]
                                .margin_bottom
                                ? this.props.canvasStyle.elementsFont[item.name]
                                    .margin_bottom
                                : "0"
                            }
                            disabled={false}
                            onChange={(e) => {
                              this.spaceAfterCounterChange(
                                e,
                                "margin_bottom",
                                item
                              );
                            }}
                            plusClick={() =>
                              this.spaceAfterCounterPlus(
                                this.props.canvasStyle &&
                                  this.props.canvasStyle.elementsFont &&
                                  this.props.canvasStyle.elementsFont[
                                    item.name
                                  ] &&
                                  this.props.canvasStyle.elementsFont[item.name]
                                    .margin_bottom
                                  ? this.props.canvasStyle.elementsFont[
                                      item.name
                                    ].margin_bottom
                                  : "0",
                                "margin_bottom",
                                item
                              )
                            }
                          />
                        </div>
                        <Col sm="7" className="reset-style-link">
                          <span
                            style={{
                              display: "flex",

                              marginTop: "20px",
                            }}
                            onClick={() => {
                              // UTILS.resetTextAndSave(
                              //   "font-family",
                              //   item.name,
                              //   this.props.layoutList,
                              //   this.props.layout,
                              //   this.props.layoutArray,
                              //  'f'+ shortid(),
                              //   this.props.replace_microsite,
                              //   this.props.layoutTitle,
                              //   this.state.selectedOverrideFont
                              // );
                              this.resetStyle(item);
                            }}
                          >
                            Reset Style
                          </span>
                          <button
                            className="overrideButton"
                            onClick={() => {
                              let itemName = JSON.stringify(item.name);
                              UTILS.resetTextAndSave(
                                "font-family",
                                item.name,
                                this.props.layoutList,
                                this.props.layout,
                                this.props.layoutArray,
                                "f" + shortid(),
                                this.props.replace_microsite,
                                this.props.layoutTitle,
                                this.state.selectedOverrideFont
                              );
                              // this.resetStyle(item)
                              this.addTextPropertyAndSave(
                                "font-family",
                                itemName,
                                this.props.canvasStyle.elementsFont[item.name]
                              );
                            }}
                          >
                            Override All {`${item.label}`} Tags
                          </button>
                        </Col>
                      </Collapse>
                    </Row>
                  ))}
              </TabPane>
              <TabPane tabId="3">
                <Row className="">
                  <Col sm="12">
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        className="padding-section"
                        style={{ marginTop: "10px", marginBottom: "20px" }}
                      >
                        <div className="heading">Canvas Width</div>
                      </div>
                      <div className="modalContentWrapper">
                        <div
                          style={{
                            justifyContent: "center",
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "center",
                              width: "50%",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "50%",

                                alignItems: "center",
                              }}
                            >
                              <div>Width</div>
                              <input
                                onChange={(e) => {
                                  this.widthOnChange(e);
                                }}
                                type="checkbox"
                                name="width"
                                defaultValue="widthPixel"
                                checked={
                                  this.props.containerWidth !== "100%"
                                    ? true
                                    : false
                                }
                              />
                            </div>

                            <div className="widthCounterWrap">
                              <Counter
                                // label="Width"
                                minusClick={this.decrementWidth}
                                valueContent={this.state.pixelWidth}
                                disabled={this.props.containerWidth === "100%"
                                  ? true
                                  : false}
                                onChange={(e) => {
                                  e.preventDefault();
                                  this.counterValChange(e);
                                }}
                                plusClick={this.incrementWidth}
                              />
                              {this.state.pixel && (
                                <div className="quickWidthOptions">
                                  <span
                                    onClick={() => {
                                      this.quickWidthOption(600);
                                    }}
                                  >
                                    600,
                                  </span>
                                  <span
                                    onClick={() => {
                                      this.quickWidthOption(800);
                                    }}
                                  >
                                    800,
                                  </span>
                                  <span
                                    onClick={() => {
                                      this.quickWidthOption(1000);
                                    }}
                                  >
                                    1000,
                                  </span>
                                  <span
                                    onClick={() => {
                                      this.quickWidthOption(1200);
                                    }}
                                  >
                                    1200
                                  </span>
                                </div>
                              )}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                marginTop: "10px",
                                marginLeft: "10px",
                                flexDirection: "column",
                              }}
                            >
                              PX
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "50%",

                              alignItems: "center",
                            }}
                          >
                            Full-width (100%)
                            <input
                              onChange={(e) => {
                                this.widthOnChange(e);
                              }}
                              type="checkbox"
                              name="width"
                              defaultValue="widthPercentage"
                              checked={
                                this.props.containerWidth == "100%"
                                  ? true
                                  : false
                              }
                            />
                          </div>
                        </div>
                      </div>

                      {this.props.containerWidth !== "100%" ? (
                        <div
                          style={{
                            justifyContent: "center",
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                          className="modalContentWrapper"
                        >
                          <input
                            type="checkbox"
                            id="fullWidthCheck"
                            name="fullwidth"
                            // value="percentage"
                            onChange={(e) => {
                              // this.widthToggle(e, "width");
                              this.props.pushEnableWidthForRow(
                                e.target.checked ? true : false
                              );
                            }}
                            checked={
                              this.props.enableWidthForRow ? true : false
                            }
                          />
                          <div>
                            Keep “full-width” approach for canvas and
                            backgrounds of outer rows
                          </div>
                        </div>
                      ) : null}
                    </div>

                    <div
                      className="padding-section"
                      style={{ marginTop: "30px", marginBottom: "5px" }}
                    >
                      <div className="heading">Rows Padding (All Rows)</div>
                    </div>
                    <div className="modalContentWrapper">
                      <div className="wrap padding-section">
                        <div
                          className="heading-row"
                          style={{ justifyContent: "flex-end" }}
                        >
                          <UnitSelector
                            value={
                              this.state.canvasRowsPaddingUnit
                                ? this.state.canvasRowsPaddingUnit
                                : "px"
                            }
                            onChange={(e) => {
                              this.unitValueChange(e, "canvasRowsPaddingUnit");
                            }}
                          />
                        </div>
                        <div className="d-flex" style={{ columnGap: "5px" }}>
                          <div style={{ width: "50%" }}>
                            <div className="heading-row">
                              <div>Desktop</div>
                            </div>
                            <div className="options">
                              <div className="d-block">
                                <Counter
                                  label="Left"
                                  small={
                                    this.state.canvasRowsPaddingUnit === "%"
                                      ? "percent"
                                      : "pixel"
                                  }
                                  minusClick={() =>
                                    this.counterMinus(
                                      this.state.canvasRowsPadding[3],
                                      "canvasRowsPadding",
                                      3
                                    )
                                  }
                                  valueContent={this.state.canvasRowsPadding[3]}
                                  disabled={false}
                                  onChange={(e) => {
                                    this.counterChange(
                                      e,
                                      "canvasRowsPadding",
                                      3
                                    );
                                  }}
                                  plusClick={() =>
                                    this.counterPlus(
                                      this.state.canvasRowsPadding[3],
                                      "canvasRowsPadding",
                                      3
                                    )
                                  }
                                />
                              </div>
                              <div className="d-block">
                                <Counter
                                  label="Right"
                                  small={
                                    this.state.canvasRowsPaddingUnit === "%"
                                      ? "percent"
                                      : "pixel"
                                  }
                                  minusClick={() =>
                                    this.counterMinus(
                                      this.state.canvasRowsPadding[1],
                                      "canvasRowsPadding",
                                      1
                                    )
                                  }
                                  valueContent={this.state.canvasRowsPadding[1]}
                                  disabled={false}
                                  onChange={(e) => {
                                    this.counterChange(
                                      e,
                                      "canvasRowsPadding",
                                      1
                                    );
                                  }}
                                  plusClick={() =>
                                    this.counterPlus(
                                      this.state.canvasRowsPadding[1],
                                      "canvasRowsPadding",
                                      1
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div style={{ width: "50%" }}>
                            <div className="heading-row">
                              <div>Mobile</div>
                            </div>
                            <div className="options">
                              <div className="d-block">
                                <Counter
                                  label="Left"
                                  small={
                                    this.state.canvasRowsPaddingUnit === "%"
                                      ? "percent"
                                      : "pixel"
                                  }
                                  minusClick={() =>
                                    this.counterMinus(
                                      this.state.canvasRowsPaddingMobile[3],
                                      "canvasRowsPaddingMobile",
                                      3
                                    )
                                  }
                                  valueContent={
                                    this.state.canvasRowsPaddingMobile[3]
                                  }
                                  disabled={false}
                                  onChange={(e) => {
                                    this.counterChange(
                                      e,
                                      "canvasRowsPaddingMobile",
                                      3
                                    );
                                  }}
                                  plusClick={() =>
                                    this.counterPlus(
                                      this.state.canvasRowsPaddingMobile[3],
                                      "canvasRowsPaddingMobile",
                                      3
                                    )
                                  }
                                />
                              </div>
                              <div className="d-block">
                                <Counter
                                  label="Right"
                                  small={
                                    this.state.canvasRowsPaddingUnit === "%"
                                      ? "percent"
                                      : "pixel"
                                  }
                                  minusClick={() =>
                                    this.counterMinus(
                                      this.state.canvasRowsPaddingMobile[1],
                                      "canvasRowsPaddingMobile",
                                      1
                                    )
                                  }
                                  valueContent={
                                    this.state.canvasRowsPaddingMobile[1]
                                  }
                                  disabled={false}
                                  onChange={(e) => {
                                    this.counterChange(
                                      e,
                                      "canvasRowsPaddingMobile",
                                      1
                                    );
                                  }}
                                  plusClick={() =>
                                    this.counterPlus(
                                      this.state.canvasRowsPaddingMobile[1],
                                      "canvasRowsPaddingMobile",
                                      1
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="wrap padding-section"
                      style={{
                        columnGap: "5px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        className="padding-section"
                        style={{ marginTop: "30px", marginBottom: "20px" }}
                      >
                        <div className="heading">Gutter Space</div>
                      </div>
                      <div className="modalContentWrapper">
                        <div
                          style={{
                            columnGap: "5px",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <div style={{ width: "50%" }}>
                            <div className="heading-row">Desktop</div>
                            <div className="options">
                              <Counter
                                label="Gutter Space"
                                minusClick={() =>
                                  this.counterMinus(
                                    this.state.columnGap
                                      ? this.state.columnGap
                                      : "0",
                                    "columnGap"
                                  )
                                }
                                valueContent={
                                  this.state.columnGap
                                    ? this.state.columnGap
                                    : "0"
                                }
                                disabled={false}
                                onChange={(e) => {
                                  this.counterChange(e, "columnGap");
                                }}
                                plusClick={() => {
                                  this.counterPlus(
                                    this.state.columnGap
                                      ? this.state.columnGap
                                      : "0",
                                    "columnGap"
                                  );
                                }}
                              />
                            </div>
                          </div>
                          <div style={{ width: "50%" }}>
                            <div className="heading-row">Mobile</div>
                            <div className="options">
                              <Counter
                                label="Gutter Space"
                                minusClick={() =>
                                  this.counterMinus(
                                    this.state.rowGap ? this.state.rowGap : "0",
                                    "rowGap"
                                  )
                                }
                                valueContent={
                                  this.state.rowGap ? this.state.rowGap : "0"
                                }
                                disabled={false}
                                onChange={(e) => {
                                  this.counterChange(e, "rowGap");
                                }}
                                plusClick={() => {
                                  this.counterPlus(
                                    this.state.rowGap ? this.state.rowGap : "0",
                                    "rowGap"
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="wrap padding-section">
                      <div
                        style={{ marginTop: "30px", marginBottom: "5px" }}
                        className="padding-section"
                      >
                        <div className="heading">Container Padding</div>
                      </div>
                      <div className="modalContentWrapper">
                        <div
                          className="heading-row"
                          style={{ justifyContent: "flex-end" }}
                        >
                          <UnitSelector
                            value={
                              this.state.canvasMarginUnit
                                ? this.state.canvasMarginUnit
                                : "px"
                            }
                            onChange={(e) => {
                              this.unitValueChange(e, "canvasMarginUnit");
                            }}
                          />
                        </div>

                        <div className="d-flex" style={{ columnGap: "5px" }}>
                          <div style={{ width: "50%" }}>
                            <div className="heading-row">
                              <div>Desktop</div>
                            </div>
                            <div className="options">
                              <div className="d-block">
                                {" "}
                                <Counter
                                  label="Top"
                                  small={
                                    this.state.canvasMarginUnit === "%"
                                      ? "percent"
                                      : "pixel"
                                  }
                                  minusClick={() =>
                                    this.counterMinus(
                                      this.state.canvasMargin[0],
                                      "canvasMargin",
                                      0
                                    )
                                  }
                                  valueContent={this.state.canvasMargin[0]}
                                  disabled={false}
                                  onChange={(e) => {
                                    this.counterChange(e, "canvasMargin", 0);
                                  }}
                                  plusClick={() => {
                                    this.counterPlus(
                                      this.state.canvasMargin[0],
                                      "canvasMargin",
                                      0
                                    );
                                  }}
                                />
                              </div>

                              <div className="d-block">
                                <Counter
                                  label="Bottom"
                                  small={
                                    this.state.canvasMarginUnit === "%"
                                      ? "percent"
                                      : "pixel"
                                  }
                                  minusClick={() =>
                                    this.counterMinus(
                                      this.state.canvasMargin[1],
                                      "canvasMargin",
                                      1
                                    )
                                  }
                                  valueContent={this.state.canvasMargin[1]}
                                  disabled={false}
                                  onChange={(e) => {
                                    this.counterChange(e, "canvasMargin", 1);
                                  }}
                                  plusClick={() =>
                                    this.counterPlus(
                                      this.state.canvasMargin[1],
                                      "canvasMargin",
                                      1
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>

                          <div style={{ width: "50%" }}>
                            <div className="heading-row">Mobile</div>
                            <div className="options">
                              <div className="d-block">
                                <Counter
                                  label="Top"
                                  small={
                                    this.state.canvasMarginUnit === "%"
                                      ? "percent"
                                      : "pixel"
                                  }
                                  minusClick={() =>
                                    this.counterMinus(
                                      this.state.canvasMarginMobile[0],
                                      "canvasMarginMobile",
                                      0
                                    )
                                  }
                                  valueContent={
                                    this.state.canvasMarginMobile[0]
                                  }
                                  disabled={false}
                                  onChange={(e) => {
                                    this.counterChange(
                                      e,
                                      "canvasMarginMobile",
                                      0
                                    );
                                  }}
                                  plusClick={() => {
                                    this.counterPlus(
                                      this.state.canvasMarginMobile[0],
                                      "canvasMarginMobile",
                                      0
                                    );
                                  }}
                                />
                              </div>
                              <div className="d-block">
                                <Counter
                                  label="Bottom"
                                  small={
                                    this.state.canvasMarginUnit === "%"
                                      ? "percent"
                                      : "pixel"
                                  }
                                  minusClick={() =>
                                    this.counterMinus(
                                      this.state.canvasMarginMobile[1],
                                      "canvasMarginMobile",
                                      1
                                    )
                                  }
                                  valueContent={
                                    this.state.canvasMarginMobile[1]
                                  }
                                  disabled={false}
                                  onChange={(e) => {
                                    this.counterChange(
                                      e,
                                      "canvasMarginMobile",
                                      1
                                    );
                                  }}
                                  plusClick={() =>
                                    this.counterPlus(
                                      this.state.canvasMarginMobile[1],
                                      "canvasMarginMobile",
                                      1
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="wrap padding-section">
                        <div
                          style={{ marginTop: "30px", marginBottom: "5px" }}
                          className="padding-section"
                        >
                          <div className="heading">Canvas Padding</div>
                        </div>
                        <div className="modalContentWrapper">
                          {" "}
                          <div
                            className="heading-row"
                            style={{ justifyContent: "flex-end" }}
                          >
                            <UnitSelector
                              value={
                                this.state.canvasPaddingUnit
                                  ? this.state.canvasPaddingUnit
                                  : "px"
                              }
                              onChange={(e) => {
                                this.unitValueChange(e, "canvasPaddingUnit");
                              }}
                            />
                          </div>
                          <div className="d-flex" style={{ columnGap: "5px" }}>
                            <div style={{ width: "50%" }}>
                              <div className="heading-row">
                                <div>Desktop</div>
                              </div>
                              <div className="options">
                                <div style={{ marginRight: "20px" }}>
                                  <Counter
                                    label="Top"
                                    small={
                                      this.state.canvasPaddingUnit === "%"
                                        ? "percent"
                                        : "pixel"
                                    }
                                    minusClick={() =>
                                      this.counterMinus(
                                        this.state.canvasPadding[0],
                                        "canvasPadding",
                                        0
                                      )
                                    }
                                    valueContent={this.state.canvasPadding[0]}
                                    disabled={false}
                                    onChange={(e) => {
                                      this.counterChange(e, "canvasPadding", 0);
                                    }}
                                    plusClick={() => {
                                      this.counterPlus(
                                        this.state.canvasPadding[0],
                                        "canvasPadding",
                                        0
                                      );
                                    }}
                                  />

                                  <Counter
                                    label="Left"
                                    small={
                                      this.state.canvasPaddingUnit === "%"
                                        ? "percent"
                                        : "pixel"
                                    }
                                    minusClick={() =>
                                      this.counterMinus(
                                        this.state.canvasPadding[3],
                                        "canvasPadding",
                                        3
                                      )
                                    }
                                    valueContent={this.state.canvasPadding[3]}
                                    disabled={false}
                                    onChange={(e) => {
                                      this.counterChange(e, "canvasPadding", 3);
                                    }}
                                    plusClick={() =>
                                      this.counterPlus(
                                        this.state.canvasPadding[3],
                                        "canvasPadding",
                                        3
                                      )
                                    }
                                  />
                                </div>
                                <div className="d-block">
                                  <Counter
                                    label="Bottom"
                                    small={
                                      this.state.canvasPaddingUnit === "%"
                                        ? "percent"
                                        : "pixel"
                                    }
                                    minusClick={() =>
                                      this.counterMinus(
                                        this.state.canvasPadding[2],
                                        "canvasPadding",
                                        2
                                      )
                                    }
                                    valueContent={this.state.canvasPadding[2]}
                                    disabled={false}
                                    onChange={(e) => {
                                      this.counterChange(e, "canvasPadding", 2);
                                    }}
                                    plusClick={() =>
                                      this.counterPlus(
                                        this.state.canvasPadding[2],
                                        "canvasPadding",
                                        2
                                      )
                                    }
                                  />
                                  <Counter
                                    label="Right"
                                    small={
                                      this.state.canvasPaddingUnit === "%"
                                        ? "percent"
                                        : "pixel"
                                    }
                                    minusClick={() =>
                                      this.counterMinus(
                                        this.state.canvasPadding[1],
                                        "canvasPadding",
                                        1
                                      )
                                    }
                                    valueContent={this.state.canvasPadding[1]}
                                    disabled={false}
                                    onChange={(e) => {
                                      this.counterChange(e, "canvasPadding", 1);
                                    }}
                                    plusClick={() =>
                                      this.counterPlus(
                                        this.state.canvasPadding[1],
                                        "canvasPadding",
                                        1
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </div>

                            <div style={{ width: "50%" }}>
                              <div className="heading-row">Mobile</div>
                              <div className="options">
                                <div style={{ marginRight: "20px" }}>
                                  <Counter
                                    label="Top"
                                    small={
                                      this.state.canvasPaddingUnit === "%"
                                        ? "percent"
                                        : "pixel"
                                    }
                                    minusClick={() =>
                                      this.counterMinus(
                                        this.state.canvasPaddingMobile[0],
                                        "canvasPaddingMobile",
                                        0
                                      )
                                    }
                                    valueContent={
                                      this.state.canvasPaddingMobile[0]
                                    }
                                    disabled={false}
                                    onChange={(e) => {
                                      this.counterChange(
                                        e,
                                        "canvasPaddingMobile",
                                        0
                                      );
                                    }}
                                    plusClick={() => {
                                      this.counterPlus(
                                        this.state.canvasPaddingMobile[0],
                                        "canvasPaddingMobile",
                                        0
                                      );
                                    }}
                                  />

                                  <Counter
                                    label="Left"
                                    small={
                                      this.state.canvasPaddingUnit === "%"
                                        ? "percent"
                                        : "pixel"
                                    }
                                    minusClick={() =>
                                      this.counterMinus(
                                        this.state.canvasPaddingMobile[3],
                                        "canvasPaddingMobile",
                                        3
                                      )
                                    }
                                    valueContent={
                                      this.state.canvasPaddingMobile[3]
                                    }
                                    disabled={false}
                                    onChange={(e) => {
                                      this.counterChange(
                                        e,
                                        "canvasPaddingMobile",
                                        3
                                      );
                                    }}
                                    plusClick={() =>
                                      this.counterPlus(
                                        this.state.canvasPaddingMobile[3],
                                        "canvasPaddingMobile",
                                        3
                                      )
                                    }
                                  />
                                </div>
                                <div className="d-block">
                                  <Counter
                                    label="Bottom"
                                    small={
                                      this.state.canvasPaddingUnit === "%"
                                        ? "percent"
                                        : "pixel"
                                    }
                                    minusClick={() =>
                                      this.counterMinus(
                                        this.state.canvasPaddingMobile[2],
                                        "canvasPaddingMobile",
                                        2
                                      )
                                    }
                                    valueContent={
                                      this.state.canvasPaddingMobile[2]
                                    }
                                    disabled={false}
                                    onChange={(e) => {
                                      this.counterChange(
                                        e,
                                        "canvasPaddingMobile",
                                        2
                                      );
                                    }}
                                    plusClick={() =>
                                      this.counterPlus(
                                        this.state.canvasPaddingMobile[2],
                                        "canvasPaddingMobile",
                                        2
                                      )
                                    }
                                  />
                                  <Counter
                                    label="Right"
                                    small={
                                      this.state.canvasPaddingUnit === "%"
                                        ? "percent"
                                        : "pixel"
                                    }
                                    minusClick={() =>
                                      this.counterMinus(
                                        this.state.canvasPaddingMobile[1],
                                        "canvasPaddingMobile",
                                        1
                                      )
                                    }
                                    valueContent={
                                      this.state.canvasPaddingMobile[1]
                                    }
                                    disabled={false}
                                    onChange={(e) => {
                                      this.counterChange(
                                        e,
                                        "canvasPaddingMobile",
                                        1
                                      );
                                    }}
                                    plusClick={() =>
                                      this.counterPlus(
                                        this.state.canvasPaddingMobile[1],
                                        "canvasPaddingMobile",
                                        1
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="4">
                <div className="modalContentWrapper">
                  {this.state.sameColorAlert && (
                    <Alert
                      color="danger"
                      className="flimpalert"
                      fade={true}
                      style={{
                        marginBottom: "10px",
                        position: "absolute",
                        zIndex: 9999,
                        top: "40%",
                        left: "auto",
                        right: "auto",
                        width: "90%",
                      }}
                      // toggle={onDismissDelete}
                    >
                      You have already added this color to the palette.
                    </Alert>
                  )}
                  <Row className="">
                    <Col sm="12">
                      <div className="globalColor--wrapper">
                        <button
                          className={
                            "select-various-content-button " +
                            (this.state.displayColorPicker === true
                              ? "active"
                              : "")
                          }
                          onClick={() => {
                            this.setState({
                              displayColorPicker:
                                !this.state.displayColorPicker,
                            });
                          }}
                        >
                          <svg
                            width="18.999"
                            height="19.208"
                            viewBox="0 0 18.999 19.208"
                          >
                            <path
                              id="Union_20"
                              data-name="Union 20"
                              d="M-6702-6550v-3h18v3Zm12.75-6.75c0-.994,1.485-2.608,1.5-2.625l.005.005c.153.169,1.5,1.687,1.5,2.62a1.5,1.5,0,0,1-1.5,1.5A1.5,1.5,0,0,1-6689.25-6556.75Zm-6.045,1.169-4.124-4.124a1.1,1.1,0,0,1-.332-.787,1.126,1.126,0,0,1,.332-.8l3.862-3.862-1.785-1.785,1.058-1.058,6.7,6.7a1.126,1.126,0,0,1,.332.8,1.11,1.11,0,0,1-.332.787l-4.125,4.124a1.125,1.125,0,0,1-.794.33A1.131,1.131,0,0,1-6695.3-6555.581Zm-2.8-4.919h7.186l-3.593-3.593Z"
                              transform="translate(6702.5 6568.707)"
                              fill="#0c3254"
                              stroke="rgba(0,0,0,0)"
                              strokeWidth="1"
                            />
                          </svg>
                          Add Color
                        </button>
                        {this.state.displayColorPicker ? (
                          <div
                            className="color-picker--main"
                            style={styles.popover}
                          >
                            <div
                              className="color-picker-container"
                              onClick={this.handleGlobalClose}
                              // style={styles.cover}
                            />
                            <SketchPicker
                              className="palette-sketch-picker"
                              btnLabel="Color"
                              color={this.state.currentlyAddedGlobalColor.rgb}
                              colorDefaultValue={{
                                r: 252,
                                g: 252,
                                b: 252,
                                a: 1,
                              }}
                              presetColors={this.props.preset}
                              onChange={(e) => {
                                this.setState({
                                  ...this.state,
                                  currentlyAddedGlobalColor: {
                                    rgb: e.rgb,
                                    hex: e.hex,
                                  },
                                });
                              }}
                            />
                            <button
                              className="choose-color"
                              onClick={this.addGlobalColor}
                            >
                              {" "}
                              <svg
                                width="10.783"
                                height="10.783"
                                viewBox="0 0 12.783 12.783"
                              >
                                <path
                                  id="plus-square"
                                  d="M12.836,7.444V18.228M7.444,12.836H18.228"
                                  transform="translate(-6.444 -6.444)"
                                  fill="none"
                                  stroke="#0c3254"
                                  strokeLinecap="square"
                                  strokeWidth="2"
                                />
                              </svg>
                              Add to Palette
                            </button>
                          </div>
                        ) : (
                          ""
                        )}
                        <Confirm
                          title="Clear Color Palette"
                          confirmMessage="Are you sure you want to clear all colors from the palette?"
                          classList="deleteColor select-various-content-button deletePalette"
                          element="button"
                          getConfirmation={(status) => {
                            status &&
                              this.setState(
                                {
                                  preset: [],
                                  presetAdded: [],
                                  colorGlobal: [],
                                  colorsAdded: [],
                                },
                                () => {
                                  this.props.pushGlobalColorArray(
                                    this.state.colorsAdded
                                  );
                                  this.props.pushGlobalColorPreset(
                                    this.state.preset
                                  );
                                }
                              );
                          }}
                        >
                          <svg
                            width="15.928"
                            height="17.531"
                            viewBox="0 0 15.928 17.531"
                          >
                            <g id="trash" transform="translate(-2.25 -1.25)">
                              <path
                                id="Path_391"
                                data-name="Path 391"
                                d="M3,6H17.428"
                                transform="translate(0 -0.794)"
                                fill="none"
                                stroke="#0c3254"
                                strokeLinecap="square"
                                strokeWidth="1.5"
                              />
                              <path
                                id="Path_392"
                                data-name="Path 392"
                                d="M16.222,5.206V16.428a1.6,1.6,0,0,1-1.6,1.6H6.6a1.6,1.6,0,0,1-1.6-1.6V5.206m2.4,0V3.6A1.6,1.6,0,0,1,9.008,2h3.206a1.6,1.6,0,0,1,1.6,1.6v1.6"
                                transform="translate(-0.397 0)"
                                fill="none"
                                stroke="#0c3254"
                                strokeLinecap="square"
                                strokeWidth="1.5"
                              />
                              <path
                                id="Path_395"
                                data-name="Path 395"
                                d="M0,0V4.809"
                                transform="translate(8.611 9.214)"
                                fill="none"
                                stroke="#0c3254"
                                strokeLinecap="square"
                                strokeWidth="1.5"
                              />
                              <path
                                id="Path_394"
                                data-name="Path 394"
                                d="M0,0V4.809"
                                transform="translate(11.817 9.214)"
                                fill="none"
                                stroke="#0c3254"
                                strokeLinecap="square"
                                strokeWidth="1.5"
                              />
                            </g>
                          </svg>
                          Clear Palette
                        </Confirm>
                      </div>
                      {globalColorsPalette}
                    </Col>
                  </Row>
                </div>
              </TabPane>

              {/* {this.state.changesStored ? (
                      <Alert className="saved-changes" color="success">
                        Changes are stored successfully!
                      </Alert>
                    ) : null} */}
            </TabContent>
          </div>

          {this.state.saving ? (
            <div className="savingStyle">
              <div className="loading"></div>
              <small style={{ marginTop: "15px" }}>Please wait...</small>
            </div>
          ) : !this.state.saving && this.state.savingError ? (
            <div>Something went wrong </div>
          ) : null}
          {this.state.savingOk && (
            <div className="savingStyle">
              <div className="wrapperSaved">
                <svg
                  version="1.1"
                  id="Layer_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 98.5 98.5"
                  enableBackground="new 0 0 98.5 98.5"
                >
                  <path
                    className="checkmark"
                    fill="none"
                    strokeWidth="8"
                    strokeMiterlimit="10"
                    d="M81.7,17.8C73.5,9.3,62,4,49.2,4
C24.3,4,4,24.3,4,49.2s20.3,45.2,45.2,45.2s45.2-20.3,45.2-45.2c0-8.6-2.4-16.6-6.5-23.4l0,0L45.6,68.2L24.7,47.3"
                  />
                </svg>
              </div>
              <small style={{ marginTop: "15px" }}>Saved successfully.</small>
            </div>
          )}
        </div>
      </Popup>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    glblClrs: state.present.colorsGlobal,
    preset: state.present.preset,
    containerBg: state.present.containerBgColor,
    surroundBg: state.present.surroundBg,
    containerWidth: state.present.containerWidth,
    pixel: state.present.pixel,
    percentage: state.present.percentage,
    imagesGlobal: state.present.imagesGlobal,
    bgRepeat: state.present.bgRepeat,
    bgSize: state.present.bgSize,
    bgContainerRepeat: state.present.bgContainerRepeat,
    bgContainerSize: state.present.bgContainerSize,
    bgImage: state.present.bgImage,
    bgImageId: state.present.bgImageId,
    bgImageContainer: state.present.bgImageContainer,
    bgImageContainerId: state.present.bgImageContainerId,
    bgVideo: state.present.bgVideo,
    bgVideoId: state.present.bgVideoId,
    bgType: state.present.bgType,
    bgImageIndex: state.present.bgImageIndex,
    layoutTitle: state.present.layoutTitle,
    layout: state.present.layout,
    storeDATA: state.present,
    layoutList: state.present.layoutList,
    selectedFont: state.present.selectedFont,
    hamburgerColor: state.present.hamburgerColor,
    enableWidthForRow: state.present.enableWidthForRow,
    canvasStyle: state.present.canvasStyle,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    empty_preset: (index) => dispatch(actionTypes.empty_preset(index)),
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
    pushBgColor: (color) => dispatch(actionTypes.add_bg(color)),
    pushBGContainerimage: (image, id) =>
      dispatch(
        actionTypes.bg_image_container({
          bgImageContainer: image,
          bgImageContainerId: id,
        })
      ),
    pushBgContainerRepeat: (bgRepeat) =>
      dispatch(actionTypes.bg_repeat_container(bgRepeat)),
    pushBgContainerSize: (bgSize) =>
      dispatch(actionTypes.bg_size_container(bgSize)),
    pushBGimage: (image, id) =>
      dispatch(actionTypes.bg_image({ bgImage: image, bgImageId: id })),
    pushBGImages: (images) => dispatch(actionTypes.bg_images(images)),
    pushBGIndex: (index) => dispatch(actionTypes.bg_image_index(index)),
    pushBgRepeat: (bgRepeat) => dispatch(actionTypes.bg_repeat(bgRepeat)),
    pushBgSize: (bgSize) => dispatch(actionTypes.bg_size(bgSize)),
    pushBGType: (type) => dispatch(actionTypes.bg_type(type)),
    pushBGVideo: (video, id) =>
      dispatch(actionTypes.bg_video({ bgVideo: video, bgVideoId: id })),
    pushCanvasColumnGap: (gap) => dispatch(actionTypes.canvas_column_gap(gap)),
    pushCanvasMargin: (margin) => dispatch(actionTypes.canvas_margin(margin)),
    pushCanvasMarginMobile: (margin) =>
      dispatch(actionTypes.canvas_margin_mobile(margin)),
    pushCanvasMarginUnit: (unit) =>
      dispatch(actionTypes.canvas_margin_unit(unit)),
    pushCanvasPadding: (padding) =>
      dispatch(actionTypes.canvas_padding(padding)),
    pushCanvasPaddingMobile: (padding) =>
      dispatch(actionTypes.canvas_padding_mobile(padding)),
    pushCanvasPaddingUnit: (unit) =>
      dispatch(actionTypes.canvas_padding_unit(unit)),
    pushCanvasRowGap: (gap) => dispatch(actionTypes.canvas_row_gap(gap)),
    pushCanvasRowsPadding: (padding) =>
      dispatch(actionTypes.canvas_rows_padding(padding)),
    pushCanvasRowsPaddingMobile: (padding) =>
      dispatch(actionTypes.canvas_rows_padding_mobile(padding)),
    pushCanvasRowsPaddingUnit: (unit) =>
      dispatch(actionTypes.canvas_rows_padding_unit(unit)),
    pushContainerWidth: (width) => dispatch(actionTypes.container_width(width)),
    pushElementFonts: (value) =>
      dispatch(actionTypes.override_element_fonts(value)),
    pushEnableWidthForRow: (index) =>
      dispatch(actionTypes.enable_width_for_row(index)),
    pushGlobalColorArray: (colorGlobal) =>
      dispatch(actionTypes.global_colors(colorGlobal)),
    pushGlobalColorPreset: (presetColor) =>
      dispatch(actionTypes.preset(presetColor)),
    pushOverrideFont: (value) =>
      dispatch(actionTypes.override_canvas_font(value)),
    pushPercentage: (percentageVal) =>
      dispatch(actionTypes.percentage(percentageVal)),
    pushPixel: (pixelVal) => dispatch(actionTypes.pixel(pixelVal)),
    pushSurroundBg: (color) => dispatch(actionTypes.add_bg_surround(color)),
    pushSelectedFont: (font) => dispatch(actionTypes.add_font(font)),
    replace_microsite: (index) =>
      dispatch(actionTypes.replace_microsite(index)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Style);
